// Infinite Options Docs:
// https://docs.theshoppad.com/article/634-event-api

(function ($) {
  /*
	 _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
				   |__/

 Version: 1.9.0
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
	Docs: http://kenwheeler.github.io/slick
	Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
  (function (i) {
    "use strict";
    "function" == typeof define && define.amd
      ? define(["jquery"], i)
      : "undefined" != typeof exports
      ? (module.exports = i(require("jquery")))
      : i(jQuery);
  })(function (i) {
    "use strict";
    var e = window.Slick || {};
    (e = (function () {
      function e(e, o) {
        var s,
          n = this;
        (n.defaults = {
          accessibility: !0,
          adaptiveHeight: !1,
          appendArrows: i(e),
          appendDots: i(e),
          arrows: !0,
          asNavFor: null,
          prevArrow:
            '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
          nextArrow:
            '<button class="slick-next" aria-label="Next" type="button">Next</button>',
          autoplay: !1,
          autoplaySpeed: 3e3,
          centerMode: !1,
          centerPadding: "50px",
          cssEase: "ease",
          customPaging: function (e, t) {
            return i('<button type="button" />').text(t + 1);
          },
          dots: !1,
          dotsClass: "slick-dots",
          draggable: !0,
          easing: "linear",
          edgeFriction: 0.35,
          fade: !1,
          focusOnSelect: !1,
          focusOnChange: !1,
          infinite: !0,
          initialSlide: 0,
          lazyLoad: "ondemand",
          mobileFirst: !1,
          pauseOnHover: !0,
          pauseOnFocus: !0,
          pauseOnDotsHover: !1,
          respondTo: "window",
          responsive: null,
          rows: 1,
          rtl: !1,
          slide: "",
          slidesPerRow: 1,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 500,
          swipe: !0,
          swipeToSlide: !1,
          touchMove: !0,
          touchThreshold: 5,
          useCSS: !0,
          useTransform: !0,
          variableWidth: !1,
          vertical: !1,
          verticalSwiping: !1,
          waitForAnimate: !0,
          zIndex: 1e3,
        }),
          (n.initials = {
            animating: !1,
            dragging: !1,
            autoPlayTimer: null,
            currentDirection: 0,
            currentLeft: null,
            currentSlide: 0,
            direction: 1,
            $dots: null,
            listWidth: null,
            listHeight: null,
            loadIndex: 0,
            $nextArrow: null,
            $prevArrow: null,
            scrolling: !1,
            slideCount: null,
            slideWidth: null,
            $slideTrack: null,
            $slides: null,
            sliding: !1,
            slideOffset: 0,
            swipeLeft: null,
            swiping: !1,
            $list: null,
            touchObject: {},
            transformsEnabled: !1,
            unslicked: !1,
          }),
          i.extend(n, n.initials),
          (n.activeBreakpoint = null),
          (n.animType = null),
          (n.animProp = null),
          (n.breakpoints = []),
          (n.breakpointSettings = []),
          (n.cssTransitions = !1),
          (n.focussed = !1),
          (n.interrupted = !1),
          (n.hidden = "hidden"),
          (n.paused = !0),
          (n.positionProp = null),
          (n.respondTo = null),
          (n.rowCount = 1),
          (n.shouldClick = !0),
          (n.$slider = i(e)),
          (n.$slidesCache = null),
          (n.transformType = null),
          (n.transitionType = null),
          (n.visibilityChange = "visibilitychange"),
          (n.windowWidth = 0),
          (n.windowTimer = null),
          (s = i(e).data("slick") || {}),
          (n.options = i.extend({}, n.defaults, o, s)),
          (n.currentSlide = n.options.initialSlide),
          (n.originalSettings = n.options),
          "undefined" != typeof document.mozHidden
            ? ((n.hidden = "mozHidden"),
              (n.visibilityChange = "mozvisibilitychange"))
            : "undefined" != typeof document.webkitHidden &&
              ((n.hidden = "webkitHidden"),
              (n.visibilityChange = "webkitvisibilitychange")),
          (n.autoPlay = i.proxy(n.autoPlay, n)),
          (n.autoPlayClear = i.proxy(n.autoPlayClear, n)),
          (n.autoPlayIterator = i.proxy(n.autoPlayIterator, n)),
          (n.changeSlide = i.proxy(n.changeSlide, n)),
          (n.clickHandler = i.proxy(n.clickHandler, n)),
          (n.selectHandler = i.proxy(n.selectHandler, n)),
          (n.setPosition = i.proxy(n.setPosition, n)),
          (n.swipeHandler = i.proxy(n.swipeHandler, n)),
          (n.dragHandler = i.proxy(n.dragHandler, n)),
          (n.keyHandler = i.proxy(n.keyHandler, n)),
          (n.instanceUid = t++),
          (n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
          n.registerBreakpoints(),
          n.init(!0);
      }
      var t = 0;
      return e;
    })()),
      (e.prototype.activateADA = function () {
        var i = this;
        i.$slideTrack
          .find(".slick-active")
          .attr({ "aria-hidden": "false" })
          .find("a, input, button, select")
          .attr({ tabindex: "0" });
      }),
      (e.prototype.addSlide = e.prototype.slickAdd =
        function (e, t, o) {
          var s = this;
          if ("boolean" == typeof t) (o = t), (t = null);
          else if (t < 0 || t >= s.slideCount) return !1;
          s.unload(),
            "number" == typeof t
              ? 0 === t && 0 === s.$slides.length
                ? i(e).appendTo(s.$slideTrack)
                : o
                ? i(e).insertBefore(s.$slides.eq(t))
                : i(e).insertAfter(s.$slides.eq(t))
              : o === !0
              ? i(e).prependTo(s.$slideTrack)
              : i(e).appendTo(s.$slideTrack),
            (s.$slides = s.$slideTrack.children(this.options.slide)),
            s.$slideTrack.children(this.options.slide).detach(),
            s.$slideTrack.append(s.$slides),
            s.$slides.each(function (e, t) {
              i(t).attr("data-slick-index", e);
            }),
            (s.$slidesCache = s.$slides),
            s.reinit();
        }),
      (e.prototype.animateHeight = function () {
        var i = this;
        if (
          1 === i.options.slidesToShow &&
          i.options.adaptiveHeight === !0 &&
          i.options.vertical === !1
        ) {
          var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
          i.$list.animate({ height: e }, i.options.speed);
        }
      }),
      (e.prototype.animateSlide = function (e, t) {
        var o = {},
          s = this;
        s.animateHeight(),
          s.options.rtl === !0 && s.options.vertical === !1 && (e = -e),
          s.transformsEnabled === !1
            ? s.options.vertical === !1
              ? s.$slideTrack.animate(
                  { left: e },
                  s.options.speed,
                  s.options.easing,
                  t
                )
              : s.$slideTrack.animate(
                  { top: e },
                  s.options.speed,
                  s.options.easing,
                  t
                )
            : s.cssTransitions === !1
            ? (s.options.rtl === !0 && (s.currentLeft = -s.currentLeft),
              i({ animStart: s.currentLeft }).animate(
                { animStart: e },
                {
                  duration: s.options.speed,
                  easing: s.options.easing,
                  step: function (i) {
                    (i = Math.ceil(i)),
                      s.options.vertical === !1
                        ? ((o[s.animType] = "translate(" + i + "px, 0px)"),
                          s.$slideTrack.css(o))
                        : ((o[s.animType] = "translate(0px," + i + "px)"),
                          s.$slideTrack.css(o));
                  },
                  complete: function () {
                    t && t.call();
                  },
                }
              ))
            : (s.applyTransition(),
              (e = Math.ceil(e)),
              s.options.vertical === !1
                ? (o[s.animType] = "translate3d(" + e + "px, 0px, 0px)")
                : (o[s.animType] = "translate3d(0px," + e + "px, 0px)"),
              s.$slideTrack.css(o),
              t &&
                setTimeout(function () {
                  s.disableTransition(), t.call();
                }, s.options.speed));
      }),
      (e.prototype.getNavTarget = function () {
        var e = this,
          t = e.options.asNavFor;
        return t && null !== t && (t = i(t).not(e.$slider)), t;
      }),
      (e.prototype.asNavFor = function (e) {
        var t = this,
          o = t.getNavTarget();
        null !== o &&
          "object" == typeof o &&
          o.each(function () {
            var t = i(this).slick("getSlick");
            t.unslicked || t.slideHandler(e, !0);
          });
      }),
      (e.prototype.applyTransition = function (i) {
        var e = this,
          t = {};
        e.options.fade === !1
          ? (t[e.transitionType] =
              e.transformType +
              " " +
              e.options.speed +
              "ms " +
              e.options.cssEase)
          : (t[e.transitionType] =
              "opacity " + e.options.speed + "ms " + e.options.cssEase),
          e.options.fade === !1 ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
      }),
      (e.prototype.autoPlay = function () {
        var i = this;
        i.autoPlayClear(),
          i.slideCount > i.options.slidesToShow &&
            (i.autoPlayTimer = setInterval(
              i.autoPlayIterator,
              i.options.autoplaySpeed
            ));
      }),
      (e.prototype.autoPlayClear = function () {
        var i = this;
        i.autoPlayTimer && clearInterval(i.autoPlayTimer);
      }),
      (e.prototype.autoPlayIterator = function () {
        var i = this,
          e = i.currentSlide + i.options.slidesToScroll;
        i.paused ||
          i.interrupted ||
          i.focussed ||
          (i.options.infinite === !1 &&
            (1 === i.direction && i.currentSlide + 1 === i.slideCount - 1
              ? (i.direction = 0)
              : 0 === i.direction &&
                ((e = i.currentSlide - i.options.slidesToScroll),
                i.currentSlide - 1 === 0 && (i.direction = 1))),
          i.slideHandler(e));
      }),
      (e.prototype.buildArrows = function () {
        var e = this;
        e.options.arrows === !0 &&
          ((e.$prevArrow = i(e.options.prevArrow).addClass("slick-arrow")),
          (e.$nextArrow = i(e.options.nextArrow).addClass("slick-arrow")),
          e.slideCount > e.options.slidesToShow
            ? (e.$prevArrow
                .removeClass("slick-hidden")
                .removeAttr("aria-hidden tabindex"),
              e.$nextArrow
                .removeClass("slick-hidden")
                .removeAttr("aria-hidden tabindex"),
              e.htmlExpr.test(e.options.prevArrow) &&
                e.$prevArrow.prependTo(e.options.appendArrows),
              e.htmlExpr.test(e.options.nextArrow) &&
                e.$nextArrow.appendTo(e.options.appendArrows),
              e.options.infinite !== !0 &&
                e.$prevArrow
                  .addClass("slick-disabled")
                  .attr("aria-disabled", "true"))
            : e.$prevArrow
                .add(e.$nextArrow)
                .addClass("slick-hidden")
                .attr({ "aria-disabled": "true", tabindex: "-1" }));
      }),
      (e.prototype.buildDots = function () {
        var e,
          t,
          o = this;
        if (o.options.dots === !0 && o.slideCount > o.options.slidesToShow) {
          for (
            o.$slider.addClass("slick-dotted"),
              t = i("<ul />").addClass(o.options.dotsClass),
              e = 0;
            e <= o.getDotCount();
            e += 1
          )
            t.append(
              i("<li />").append(o.options.customPaging.call(this, o, e))
            );
          (o.$dots = t.appendTo(o.options.appendDots)),
            o.$dots.find("li").first().addClass("slick-active");
        }
      }),
      (e.prototype.buildOut = function () {
        var e = this;
        (e.$slides = e.$slider
          .children(e.options.slide + ":not(.slick-cloned)")
          .addClass("slick-slide")),
          (e.slideCount = e.$slides.length),
          e.$slides.each(function (e, t) {
            i(t)
              .attr("data-slick-index", e)
              .data("originalStyling", i(t).attr("style") || "");
          }),
          e.$slider.addClass("slick-slider"),
          (e.$slideTrack =
            0 === e.slideCount
              ? i('<div class="slick-track"/>').appendTo(e.$slider)
              : e.$slides.wrapAll('<div class="slick-track"/>').parent()),
          (e.$list = e.$slideTrack.wrap('<div class="slick-list"/>').parent()),
          e.$slideTrack.css("opacity", 0),
          (e.options.centerMode !== !0 && e.options.swipeToSlide !== !0) ||
            (e.options.slidesToScroll = 1),
          i("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"),
          e.setupInfinite(),
          e.buildArrows(),
          e.buildDots(),
          e.updateDots(),
          e.setSlideClasses(
            "number" == typeof e.currentSlide ? e.currentSlide : 0
          ),
          e.options.draggable === !0 && e.$list.addClass("draggable");
      }),
      (e.prototype.buildRows = function () {
        var i,
          e,
          t,
          o,
          s,
          n,
          r,
          l = this;
        if (
          ((o = document.createDocumentFragment()),
          (n = l.$slider.children()),
          l.options.rows > 0)
        ) {
          for (
            r = l.options.slidesPerRow * l.options.rows,
              s = Math.ceil(n.length / r),
              i = 0;
            i < s;
            i++
          ) {
            var d = document.createElement("div");
            for (e = 0; e < l.options.rows; e++) {
              var a = document.createElement("div");
              for (t = 0; t < l.options.slidesPerRow; t++) {
                var c = i * r + (e * l.options.slidesPerRow + t);
                n.get(c) && a.appendChild(n.get(c));
              }
              d.appendChild(a);
            }
            o.appendChild(d);
          }
          l.$slider.empty().append(o),
            l.$slider
              .children()
              .children()
              .children()
              .css({
                width: 100 / l.options.slidesPerRow + "%",
                display: "inline-block",
              });
        }
      }),
      (e.prototype.checkResponsive = function (e, t) {
        var o,
          s,
          n,
          r = this,
          l = !1,
          d = r.$slider.width(),
          a = window.innerWidth || i(window).width();
        if (
          ("window" === r.respondTo
            ? (n = a)
            : "slider" === r.respondTo
            ? (n = d)
            : "min" === r.respondTo && (n = Math.min(a, d)),
          r.options.responsive &&
            r.options.responsive.length &&
            null !== r.options.responsive)
        ) {
          s = null;
          for (o in r.breakpoints)
            r.breakpoints.hasOwnProperty(o) &&
              (r.originalSettings.mobileFirst === !1
                ? n < r.breakpoints[o] && (s = r.breakpoints[o])
                : n > r.breakpoints[o] && (s = r.breakpoints[o]));
          null !== s
            ? null !== r.activeBreakpoint
              ? (s !== r.activeBreakpoint || t) &&
                ((r.activeBreakpoint = s),
                "unslick" === r.breakpointSettings[s]
                  ? r.unslick(s)
                  : ((r.options = i.extend(
                      {},
                      r.originalSettings,
                      r.breakpointSettings[s]
                    )),
                    e === !0 && (r.currentSlide = r.options.initialSlide),
                    r.refresh(e)),
                (l = s))
              : ((r.activeBreakpoint = s),
                "unslick" === r.breakpointSettings[s]
                  ? r.unslick(s)
                  : ((r.options = i.extend(
                      {},
                      r.originalSettings,
                      r.breakpointSettings[s]
                    )),
                    e === !0 && (r.currentSlide = r.options.initialSlide),
                    r.refresh(e)),
                (l = s))
            : null !== r.activeBreakpoint &&
              ((r.activeBreakpoint = null),
              (r.options = r.originalSettings),
              e === !0 && (r.currentSlide = r.options.initialSlide),
              r.refresh(e),
              (l = s)),
            e || l === !1 || r.$slider.trigger("breakpoint", [r, l]);
        }
      }),
      (e.prototype.changeSlide = function (e, t) {
        var o,
          s,
          n,
          r = this,
          l = i(e.currentTarget);
        switch (
          (l.is("a") && e.preventDefault(),
          l.is("li") || (l = l.closest("li")),
          (n = r.slideCount % r.options.slidesToScroll !== 0),
          (o = n
            ? 0
            : (r.slideCount - r.currentSlide) % r.options.slidesToScroll),
          e.data.message)
        ) {
          case "previous":
            (s =
              0 === o ? r.options.slidesToScroll : r.options.slidesToShow - o),
              r.slideCount > r.options.slidesToShow &&
                r.slideHandler(r.currentSlide - s, !1, t);
            break;
          case "next":
            (s = 0 === o ? r.options.slidesToScroll : o),
              r.slideCount > r.options.slidesToShow &&
                r.slideHandler(r.currentSlide + s, !1, t);
            break;
          case "index":
            var d =
              0 === e.data.index
                ? 0
                : e.data.index || l.index() * r.options.slidesToScroll;
            r.slideHandler(r.checkNavigable(d), !1, t),
              l.children().trigger("focus");
            break;
          default:
            return;
        }
      }),
      (e.prototype.checkNavigable = function (i) {
        var e,
          t,
          o = this;
        if (((e = o.getNavigableIndexes()), (t = 0), i > e[e.length - 1]))
          i = e[e.length - 1];
        else
          for (var s in e) {
            if (i < e[s]) {
              i = t;
              break;
            }
            t = e[s];
          }
        return i;
      }),
      (e.prototype.cleanUpEvents = function () {
        var e = this;
        e.options.dots &&
          null !== e.$dots &&
          (i("li", e.$dots)
            .off("click.slick", e.changeSlide)
            .off("mouseenter.slick", i.proxy(e.interrupt, e, !0))
            .off("mouseleave.slick", i.proxy(e.interrupt, e, !1)),
          e.options.accessibility === !0 &&
            e.$dots.off("keydown.slick", e.keyHandler)),
          e.$slider.off("focus.slick blur.slick"),
          e.options.arrows === !0 &&
            e.slideCount > e.options.slidesToShow &&
            (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide),
            e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide),
            e.options.accessibility === !0 &&
              (e.$prevArrow && e.$prevArrow.off("keydown.slick", e.keyHandler),
              e.$nextArrow && e.$nextArrow.off("keydown.slick", e.keyHandler))),
          e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler),
          e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler),
          e.$list.off("touchend.slick mouseup.slick", e.swipeHandler),
          e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler),
          e.$list.off("click.slick", e.clickHandler),
          i(document).off(e.visibilityChange, e.visibility),
          e.cleanUpSlideEvents(),
          e.options.accessibility === !0 &&
            e.$list.off("keydown.slick", e.keyHandler),
          e.options.focusOnSelect === !0 &&
            i(e.$slideTrack).children().off("click.slick", e.selectHandler),
          i(window).off(
            "orientationchange.slick.slick-" + e.instanceUid,
            e.orientationChange
          ),
          i(window).off("resize.slick.slick-" + e.instanceUid, e.resize),
          i("[draggable!=true]", e.$slideTrack).off(
            "dragstart",
            e.preventDefault
          ),
          i(window).off("load.slick.slick-" + e.instanceUid, e.setPosition);
      }),
      (e.prototype.cleanUpSlideEvents = function () {
        var e = this;
        e.$list.off("mouseenter.slick", i.proxy(e.interrupt, e, !0)),
          e.$list.off("mouseleave.slick", i.proxy(e.interrupt, e, !1));
      }),
      (e.prototype.cleanUpRows = function () {
        var i,
          e = this;
        e.options.rows > 0 &&
          ((i = e.$slides.children().children()),
          i.removeAttr("style"),
          e.$slider.empty().append(i));
      }),
      (e.prototype.clickHandler = function (i) {
        var e = this;
        e.shouldClick === !1 &&
          (i.stopImmediatePropagation(),
          i.stopPropagation(),
          i.preventDefault());
      }),
      (e.prototype.destroy = function (e) {
        var t = this;
        t.autoPlayClear(),
          (t.touchObject = {}),
          t.cleanUpEvents(),
          i(".slick-cloned", t.$slider).detach(),
          t.$dots && t.$dots.remove(),
          t.$prevArrow &&
            t.$prevArrow.length &&
            (t.$prevArrow
              .removeClass("slick-disabled slick-arrow slick-hidden")
              .removeAttr("aria-hidden aria-disabled tabindex")
              .css("display", ""),
            t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()),
          t.$nextArrow &&
            t.$nextArrow.length &&
            (t.$nextArrow
              .removeClass("slick-disabled slick-arrow slick-hidden")
              .removeAttr("aria-hidden aria-disabled tabindex")
              .css("display", ""),
            t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()),
          t.$slides &&
            (t.$slides
              .removeClass(
                "slick-slide slick-active slick-center slick-visible slick-current"
              )
              .removeAttr("aria-hidden")
              .removeAttr("data-slick-index")
              .each(function () {
                i(this).attr("style", i(this).data("originalStyling"));
              }),
            t.$slideTrack.children(this.options.slide).detach(),
            t.$slideTrack.detach(),
            t.$list.detach(),
            t.$slider.append(t.$slides)),
          t.cleanUpRows(),
          t.$slider.removeClass("slick-slider"),
          t.$slider.removeClass("slick-initialized"),
          t.$slider.removeClass("slick-dotted"),
          (t.unslicked = !0),
          e || t.$slider.trigger("destroy", [t]);
      }),
      (e.prototype.disableTransition = function (i) {
        var e = this,
          t = {};
        (t[e.transitionType] = ""),
          e.options.fade === !1 ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
      }),
      (e.prototype.fadeSlide = function (i, e) {
        var t = this;
        t.cssTransitions === !1
          ? (t.$slides.eq(i).css({ zIndex: t.options.zIndex }),
            t.$slides
              .eq(i)
              .animate({ opacity: 1 }, t.options.speed, t.options.easing, e))
          : (t.applyTransition(i),
            t.$slides.eq(i).css({ opacity: 1, zIndex: t.options.zIndex }),
            e &&
              setTimeout(function () {
                t.disableTransition(i), e.call();
              }, t.options.speed));
      }),
      (e.prototype.fadeSlideOut = function (i) {
        var e = this;
        e.cssTransitions === !1
          ? e.$slides
              .eq(i)
              .animate(
                { opacity: 0, zIndex: e.options.zIndex - 2 },
                e.options.speed,
                e.options.easing
              )
          : (e.applyTransition(i),
            e.$slides.eq(i).css({ opacity: 0, zIndex: e.options.zIndex - 2 }));
      }),
      (e.prototype.filterSlides = e.prototype.slickFilter =
        function (i) {
          var e = this;
          null !== i &&
            ((e.$slidesCache = e.$slides),
            e.unload(),
            e.$slideTrack.children(this.options.slide).detach(),
            e.$slidesCache.filter(i).appendTo(e.$slideTrack),
            e.reinit());
        }),
      (e.prototype.focusHandler = function () {
        var e = this;
        e.$slider
          .off("focus.slick blur.slick")
          .on("focus.slick", "*", function (t) {
            var o = i(this);
            setTimeout(function () {
              e.options.pauseOnFocus &&
                o.is(":focus") &&
                ((e.focussed = !0), e.autoPlay());
            }, 0);
          })
          .on("blur.slick", "*", function (t) {
            i(this);
            e.options.pauseOnFocus && ((e.focussed = !1), e.autoPlay());
          });
      }),
      (e.prototype.getCurrent = e.prototype.slickCurrentSlide =
        function () {
          var i = this;
          return i.currentSlide;
        }),
      (e.prototype.getDotCount = function () {
        var i = this,
          e = 0,
          t = 0,
          o = 0;
        if (i.options.infinite === !0)
          if (i.slideCount <= i.options.slidesToShow) ++o;
          else
            for (; e < i.slideCount; )
              ++o,
                (e = t + i.options.slidesToScroll),
                (t +=
                  i.options.slidesToScroll <= i.options.slidesToShow
                    ? i.options.slidesToScroll
                    : i.options.slidesToShow);
        else if (i.options.centerMode === !0) o = i.slideCount;
        else if (i.options.asNavFor)
          for (; e < i.slideCount; )
            ++o,
              (e = t + i.options.slidesToScroll),
              (t +=
                i.options.slidesToScroll <= i.options.slidesToShow
                  ? i.options.slidesToScroll
                  : i.options.slidesToShow);
        else
          o =
            1 +
            Math.ceil(
              (i.slideCount - i.options.slidesToShow) / i.options.slidesToScroll
            );
        return o - 1;
      }),
      (e.prototype.getLeft = function (i) {
        var e,
          t,
          o,
          s,
          n = this,
          r = 0;
        return (
          (n.slideOffset = 0),
          (t = n.$slides.first().outerHeight(!0)),
          n.options.infinite === !0
            ? (n.slideCount > n.options.slidesToShow &&
                ((n.slideOffset = n.slideWidth * n.options.slidesToShow * -1),
                (s = -1),
                n.options.vertical === !0 &&
                  n.options.centerMode === !0 &&
                  (2 === n.options.slidesToShow
                    ? (s = -1.5)
                    : 1 === n.options.slidesToShow && (s = -2)),
                (r = t * n.options.slidesToShow * s)),
              n.slideCount % n.options.slidesToScroll !== 0 &&
                i + n.options.slidesToScroll > n.slideCount &&
                n.slideCount > n.options.slidesToShow &&
                (i > n.slideCount
                  ? ((n.slideOffset =
                      (n.options.slidesToShow - (i - n.slideCount)) *
                      n.slideWidth *
                      -1),
                    (r =
                      (n.options.slidesToShow - (i - n.slideCount)) * t * -1))
                  : ((n.slideOffset =
                      (n.slideCount % n.options.slidesToScroll) *
                      n.slideWidth *
                      -1),
                    (r = (n.slideCount % n.options.slidesToScroll) * t * -1))))
            : i + n.options.slidesToShow > n.slideCount &&
              ((n.slideOffset =
                (i + n.options.slidesToShow - n.slideCount) * n.slideWidth),
              (r = (i + n.options.slidesToShow - n.slideCount) * t)),
          n.slideCount <= n.options.slidesToShow &&
            ((n.slideOffset = 0), (r = 0)),
          n.options.centerMode === !0 && n.slideCount <= n.options.slidesToShow
            ? (n.slideOffset =
                (n.slideWidth * Math.floor(n.options.slidesToShow)) / 2 -
                (n.slideWidth * n.slideCount) / 2)
            : n.options.centerMode === !0 && n.options.infinite === !0
            ? (n.slideOffset +=
                n.slideWidth * Math.floor(n.options.slidesToShow / 2) -
                n.slideWidth)
            : n.options.centerMode === !0 &&
              ((n.slideOffset = 0),
              (n.slideOffset +=
                n.slideWidth * Math.floor(n.options.slidesToShow / 2))),
          (e =
            n.options.vertical === !1
              ? i * n.slideWidth * -1 + n.slideOffset
              : i * t * -1 + r),
          n.options.variableWidth === !0 &&
            ((o =
              n.slideCount <= n.options.slidesToShow ||
              n.options.infinite === !1
                ? n.$slideTrack.children(".slick-slide").eq(i)
                : n.$slideTrack
                    .children(".slick-slide")
                    .eq(i + n.options.slidesToShow)),
            (e =
              n.options.rtl === !0
                ? o[0]
                  ? (n.$slideTrack.width() - o[0].offsetLeft - o.width()) * -1
                  : 0
                : o[0]
                ? o[0].offsetLeft * -1
                : 0),
            n.options.centerMode === !0 &&
              ((o =
                n.slideCount <= n.options.slidesToShow ||
                n.options.infinite === !1
                  ? n.$slideTrack.children(".slick-slide").eq(i)
                  : n.$slideTrack
                      .children(".slick-slide")
                      .eq(i + n.options.slidesToShow + 1)),
              (e =
                n.options.rtl === !0
                  ? o[0]
                    ? (n.$slideTrack.width() - o[0].offsetLeft - o.width()) * -1
                    : 0
                  : o[0]
                  ? o[0].offsetLeft * -1
                  : 0),
              (e += (n.$list.width() - o.outerWidth()) / 2))),
          e
        );
      }),
      (e.prototype.getOption = e.prototype.slickGetOption =
        function (i) {
          var e = this;
          return e.options[i];
        }),
      (e.prototype.getNavigableIndexes = function () {
        var i,
          e = this,
          t = 0,
          o = 0,
          s = [];
        for (
          e.options.infinite === !1
            ? (i = e.slideCount)
            : ((t = e.options.slidesToScroll * -1),
              (o = e.options.slidesToScroll * -1),
              (i = 2 * e.slideCount));
          t < i;

        )
          s.push(t),
            (t = o + e.options.slidesToScroll),
            (o +=
              e.options.slidesToScroll <= e.options.slidesToShow
                ? e.options.slidesToScroll
                : e.options.slidesToShow);
        return s;
      }),
      (e.prototype.getSlick = function () {
        return this;
      }),
      (e.prototype.getSlideCount = function () {
        var e,
          t,
          o,
          s,
          n = this;
        return (
          (s =
            n.options.centerMode === !0 ? Math.floor(n.$list.width() / 2) : 0),
          (o = n.swipeLeft * -1 + s),
          n.options.swipeToSlide === !0
            ? (n.$slideTrack.find(".slick-slide").each(function (e, s) {
                var r, l, d;
                if (
                  ((r = i(s).outerWidth()),
                  (l = s.offsetLeft),
                  n.options.centerMode !== !0 && (l += r / 2),
                  (d = l + r),
                  o < d)
                )
                  return (t = s), !1;
              }),
              (e =
                Math.abs(i(t).attr("data-slick-index") - n.currentSlide) || 1))
            : n.options.slidesToScroll
        );
      }),
      (e.prototype.goTo = e.prototype.slickGoTo =
        function (i, e) {
          var t = this;
          t.changeSlide({ data: { message: "index", index: parseInt(i) } }, e);
        }),
      (e.prototype.init = function (e) {
        var t = this;
        i(t.$slider).hasClass("slick-initialized") ||
          (i(t.$slider).addClass("slick-initialized"),
          t.buildRows(),
          t.buildOut(),
          t.setProps(),
          t.startLoad(),
          t.loadSlider(),
          t.initializeEvents(),
          t.updateArrows(),
          t.updateDots(),
          t.checkResponsive(!0),
          t.focusHandler()),
          e && t.$slider.trigger("init", [t]),
          t.options.accessibility === !0 && t.initADA(),
          t.options.autoplay && ((t.paused = !1), t.autoPlay());
      }),
      (e.prototype.initADA = function () {
        var e = this,
          t = Math.ceil(e.slideCount / e.options.slidesToShow),
          o = e.getNavigableIndexes().filter(function (i) {
            return i >= 0 && i < e.slideCount;
          });
        e.$slides
          .add(e.$slideTrack.find(".slick-cloned"))
          .attr({ "aria-hidden": "true", tabindex: "-1" })
          .find("a, input, button, select")
          .attr({ tabindex: "-1" }),
          null !== e.$dots &&
            (e.$slides
              .not(e.$slideTrack.find(".slick-cloned"))
              .each(function (t) {
                var s = o.indexOf(t);
                if (
                  (i(this).attr({
                    role: "tabpanel",
                    id: "slick-slide" + e.instanceUid + t,
                    tabindex: -1,
                  }),
                  s !== -1)
                ) {
                  var n = "slick-slide-control" + e.instanceUid + s;
                  i("#" + n).length && i(this).attr({ "aria-describedby": n });
                }
              }),
            e.$dots
              .attr("role", "tablist")
              .find("li")
              .each(function (s) {
                var n = o[s];
                i(this).attr({ role: "presentation" }),
                  i(this)
                    .find("button")
                    .first()
                    .attr({
                      role: "tab",
                      id: "slick-slide-control" + e.instanceUid + s,
                      "aria-controls": "slick-slide" + e.instanceUid + n,
                      "aria-label": s + 1 + " of " + t,
                      "aria-selected": null,
                      tabindex: "-1",
                    });
              })
              .eq(e.currentSlide)
              .find("button")
              .attr({ "aria-selected": "true", tabindex: "0" })
              .end());
        for (var s = e.currentSlide, n = s + e.options.slidesToShow; s < n; s++)
          e.options.focusOnChange
            ? e.$slides.eq(s).attr({ tabindex: "0" })
            : e.$slides.eq(s).removeAttr("tabindex");
        e.activateADA();
      }),
      (e.prototype.initArrowEvents = function () {
        var i = this;
        i.options.arrows === !0 &&
          i.slideCount > i.options.slidesToShow &&
          (i.$prevArrow
            .off("click.slick")
            .on("click.slick", { message: "previous" }, i.changeSlide),
          i.$nextArrow
            .off("click.slick")
            .on("click.slick", { message: "next" }, i.changeSlide),
          i.options.accessibility === !0 &&
            (i.$prevArrow.on("keydown.slick", i.keyHandler),
            i.$nextArrow.on("keydown.slick", i.keyHandler)));
      }),
      (e.prototype.initDotEvents = function () {
        var e = this;
        e.options.dots === !0 &&
          e.slideCount > e.options.slidesToShow &&
          (i("li", e.$dots).on(
            "click.slick",
            { message: "index" },
            e.changeSlide
          ),
          e.options.accessibility === !0 &&
            e.$dots.on("keydown.slick", e.keyHandler)),
          e.options.dots === !0 &&
            e.options.pauseOnDotsHover === !0 &&
            e.slideCount > e.options.slidesToShow &&
            i("li", e.$dots)
              .on("mouseenter.slick", i.proxy(e.interrupt, e, !0))
              .on("mouseleave.slick", i.proxy(e.interrupt, e, !1));
      }),
      (e.prototype.initSlideEvents = function () {
        var e = this;
        e.options.pauseOnHover &&
          (e.$list.on("mouseenter.slick", i.proxy(e.interrupt, e, !0)),
          e.$list.on("mouseleave.slick", i.proxy(e.interrupt, e, !1)));
      }),
      (e.prototype.initializeEvents = function () {
        var e = this;
        e.initArrowEvents(),
          e.initDotEvents(),
          e.initSlideEvents(),
          e.$list.on(
            "touchstart.slick mousedown.slick",
            { action: "start" },
            e.swipeHandler
          ),
          e.$list.on(
            "touchmove.slick mousemove.slick",
            { action: "move" },
            e.swipeHandler
          ),
          e.$list.on(
            "touchend.slick mouseup.slick",
            { action: "end" },
            e.swipeHandler
          ),
          e.$list.on(
            "touchcancel.slick mouseleave.slick",
            { action: "end" },
            e.swipeHandler
          ),
          e.$list.on("click.slick", e.clickHandler),
          i(document).on(e.visibilityChange, i.proxy(e.visibility, e)),
          e.options.accessibility === !0 &&
            e.$list.on("keydown.slick", e.keyHandler),
          e.options.focusOnSelect === !0 &&
            i(e.$slideTrack).children().on("click.slick", e.selectHandler),
          i(window).on(
            "orientationchange.slick.slick-" + e.instanceUid,
            i.proxy(e.orientationChange, e)
          ),
          i(window).on(
            "resize.slick.slick-" + e.instanceUid,
            i.proxy(e.resize, e)
          ),
          i("[draggable!=true]", e.$slideTrack).on(
            "dragstart",
            e.preventDefault
          ),
          i(window).on("load.slick.slick-" + e.instanceUid, e.setPosition),
          i(e.setPosition);
      }),
      (e.prototype.initUI = function () {
        var i = this;
        i.options.arrows === !0 &&
          i.slideCount > i.options.slidesToShow &&
          (i.$prevArrow.show(), i.$nextArrow.show()),
          i.options.dots === !0 &&
            i.slideCount > i.options.slidesToShow &&
            i.$dots.show();
      }),
      (e.prototype.keyHandler = function (i) {
        var e = this;
        i.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
          (37 === i.keyCode && e.options.accessibility === !0
            ? e.changeSlide({
                data: { message: e.options.rtl === !0 ? "next" : "previous" },
              })
            : 39 === i.keyCode &&
              e.options.accessibility === !0 &&
              e.changeSlide({
                data: { message: e.options.rtl === !0 ? "previous" : "next" },
              }));
      }),
      (e.prototype.lazyLoad = function () {
        function e(e) {
          i("img[data-lazy]", e).each(function () {
            var e = i(this),
              t = i(this).attr("data-lazy"),
              o = i(this).attr("data-srcset"),
              s = i(this).attr("data-sizes") || r.$slider.attr("data-sizes"),
              n = document.createElement("img");
            (n.onload = function () {
              e.animate({ opacity: 0 }, 100, function () {
                o && (e.attr("srcset", o), s && e.attr("sizes", s)),
                  e.attr("src", t).animate({ opacity: 1 }, 200, function () {
                    e.removeAttr(
                      "data-lazy data-srcset data-sizes"
                    ).removeClass("slick-loading");
                  }),
                  r.$slider.trigger("lazyLoaded", [r, e, t]);
              });
            }),
              (n.onerror = function () {
                e
                  .removeAttr("data-lazy")
                  .removeClass("slick-loading")
                  .addClass("slick-lazyload-error"),
                  r.$slider.trigger("lazyLoadError", [r, e, t]);
              }),
              (n.src = t);
          });
        }
        var t,
          o,
          s,
          n,
          r = this;
        if (
          (r.options.centerMode === !0
            ? r.options.infinite === !0
              ? ((s = r.currentSlide + (r.options.slidesToShow / 2 + 1)),
                (n = s + r.options.slidesToShow + 2))
              : ((s = Math.max(
                  0,
                  r.currentSlide - (r.options.slidesToShow / 2 + 1)
                )),
                (n = 2 + (r.options.slidesToShow / 2 + 1) + r.currentSlide))
            : ((s = r.options.infinite
                ? r.options.slidesToShow + r.currentSlide
                : r.currentSlide),
              (n = Math.ceil(s + r.options.slidesToShow)),
              r.options.fade === !0 &&
                (s > 0 && s--, n <= r.slideCount && n++)),
          (t = r.$slider.find(".slick-slide").slice(s, n)),
          "anticipated" === r.options.lazyLoad)
        )
          for (
            var l = s - 1, d = n, a = r.$slider.find(".slick-slide"), c = 0;
            c < r.options.slidesToScroll;
            c++
          )
            l < 0 && (l = r.slideCount - 1),
              (t = t.add(a.eq(l))),
              (t = t.add(a.eq(d))),
              l--,
              d++;
        e(t),
          r.slideCount <= r.options.slidesToShow
            ? ((o = r.$slider.find(".slick-slide")), e(o))
            : r.currentSlide >= r.slideCount - r.options.slidesToShow
            ? ((o = r.$slider
                .find(".slick-cloned")
                .slice(0, r.options.slidesToShow)),
              e(o))
            : 0 === r.currentSlide &&
              ((o = r.$slider
                .find(".slick-cloned")
                .slice(r.options.slidesToShow * -1)),
              e(o));
      }),
      (e.prototype.loadSlider = function () {
        var i = this;
        i.setPosition(),
          i.$slideTrack.css({ opacity: 1 }),
          i.$slider.removeClass("slick-loading"),
          i.initUI(),
          "progressive" === i.options.lazyLoad && i.progressiveLazyLoad();
      }),
      (e.prototype.next = e.prototype.slickNext =
        function () {
          var i = this;
          i.changeSlide({ data: { message: "next" } });
        }),
      (e.prototype.orientationChange = function () {
        var i = this;
        i.checkResponsive(), i.setPosition();
      }),
      (e.prototype.pause = e.prototype.slickPause =
        function () {
          var i = this;
          i.autoPlayClear(), (i.paused = !0);
        }),
      (e.prototype.play = e.prototype.slickPlay =
        function () {
          var i = this;
          i.autoPlay(),
            (i.options.autoplay = !0),
            (i.paused = !1),
            (i.focussed = !1),
            (i.interrupted = !1);
        }),
      (e.prototype.postSlide = function (e) {
        var t = this;
        if (
          !t.unslicked &&
          (t.$slider.trigger("afterChange", [t, e]),
          (t.animating = !1),
          t.slideCount > t.options.slidesToShow && t.setPosition(),
          (t.swipeLeft = null),
          t.options.autoplay && t.autoPlay(),
          t.options.accessibility === !0 &&
            (t.initADA(), t.options.focusOnChange))
        ) {
          var o = i(t.$slides.get(t.currentSlide));
          o.attr("tabindex", 0).focus();
        }
      }),
      (e.prototype.prev = e.prototype.slickPrev =
        function () {
          var i = this;
          i.changeSlide({ data: { message: "previous" } });
        }),
      (e.prototype.preventDefault = function (i) {
        i.preventDefault();
      }),
      (e.prototype.progressiveLazyLoad = function (e) {
        e = e || 1;
        var t,
          o,
          s,
          n,
          r,
          l = this,
          d = i("img[data-lazy]", l.$slider);
        d.length
          ? ((t = d.first()),
            (o = t.attr("data-lazy")),
            (s = t.attr("data-srcset")),
            (n = t.attr("data-sizes") || l.$slider.attr("data-sizes")),
            (r = document.createElement("img")),
            (r.onload = function () {
              s && (t.attr("srcset", s), n && t.attr("sizes", n)),
                t
                  .attr("src", o)
                  .removeAttr("data-lazy data-srcset data-sizes")
                  .removeClass("slick-loading"),
                l.options.adaptiveHeight === !0 && l.setPosition(),
                l.$slider.trigger("lazyLoaded", [l, t, o]),
                l.progressiveLazyLoad();
            }),
            (r.onerror = function () {
              e < 3
                ? setTimeout(function () {
                    l.progressiveLazyLoad(e + 1);
                  }, 500)
                : (t
                    .removeAttr("data-lazy")
                    .removeClass("slick-loading")
                    .addClass("slick-lazyload-error"),
                  l.$slider.trigger("lazyLoadError", [l, t, o]),
                  l.progressiveLazyLoad());
            }),
            (r.src = o))
          : l.$slider.trigger("allImagesLoaded", [l]);
      }),
      (e.prototype.refresh = function (e) {
        var t,
          o,
          s = this;
        (o = s.slideCount - s.options.slidesToShow),
          !s.options.infinite && s.currentSlide > o && (s.currentSlide = o),
          s.slideCount <= s.options.slidesToShow && (s.currentSlide = 0),
          (t = s.currentSlide),
          s.destroy(!0),
          i.extend(s, s.initials, { currentSlide: t }),
          s.init(),
          e || s.changeSlide({ data: { message: "index", index: t } }, !1);
      }),
      (e.prototype.registerBreakpoints = function () {
        var e,
          t,
          o,
          s = this,
          n = s.options.responsive || null;
        if ("array" === i.type(n) && n.length) {
          s.respondTo = s.options.respondTo || "window";
          for (e in n)
            if (((o = s.breakpoints.length - 1), n.hasOwnProperty(e))) {
              for (t = n[e].breakpoint; o >= 0; )
                s.breakpoints[o] &&
                  s.breakpoints[o] === t &&
                  s.breakpoints.splice(o, 1),
                  o--;
              s.breakpoints.push(t), (s.breakpointSettings[t] = n[e].settings);
            }
          s.breakpoints.sort(function (i, e) {
            return s.options.mobileFirst ? i - e : e - i;
          });
        }
      }),
      (e.prototype.reinit = function () {
        var e = this;
        (e.$slides = e.$slideTrack
          .children(e.options.slide)
          .addClass("slick-slide")),
          (e.slideCount = e.$slides.length),
          e.currentSlide >= e.slideCount &&
            0 !== e.currentSlide &&
            (e.currentSlide = e.currentSlide - e.options.slidesToScroll),
          e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0),
          e.registerBreakpoints(),
          e.setProps(),
          e.setupInfinite(),
          e.buildArrows(),
          e.updateArrows(),
          e.initArrowEvents(),
          e.buildDots(),
          e.updateDots(),
          e.initDotEvents(),
          e.cleanUpSlideEvents(),
          e.initSlideEvents(),
          e.checkResponsive(!1, !0),
          e.options.focusOnSelect === !0 &&
            i(e.$slideTrack).children().on("click.slick", e.selectHandler),
          e.setSlideClasses(
            "number" == typeof e.currentSlide ? e.currentSlide : 0
          ),
          e.setPosition(),
          e.focusHandler(),
          (e.paused = !e.options.autoplay),
          e.autoPlay(),
          e.$slider.trigger("reInit", [e]);
      }),
      (e.prototype.resize = function () {
        var e = this;
        i(window).width() !== e.windowWidth &&
          (clearTimeout(e.windowDelay),
          (e.windowDelay = window.setTimeout(function () {
            (e.windowWidth = i(window).width()),
              e.checkResponsive(),
              e.unslicked || e.setPosition();
          }, 50)));
      }),
      (e.prototype.removeSlide = e.prototype.slickRemove =
        function (i, e, t) {
          var o = this;
          return (
            "boolean" == typeof i
              ? ((e = i), (i = e === !0 ? 0 : o.slideCount - 1))
              : (i = e === !0 ? --i : i),
            !(o.slideCount < 1 || i < 0 || i > o.slideCount - 1) &&
              (o.unload(),
              t === !0
                ? o.$slideTrack.children().remove()
                : o.$slideTrack.children(this.options.slide).eq(i).remove(),
              (o.$slides = o.$slideTrack.children(this.options.slide)),
              o.$slideTrack.children(this.options.slide).detach(),
              o.$slideTrack.append(o.$slides),
              (o.$slidesCache = o.$slides),
              void o.reinit())
          );
        }),
      (e.prototype.setCSS = function (i) {
        var e,
          t,
          o = this,
          s = {};
        o.options.rtl === !0 && (i = -i),
          (e = "left" == o.positionProp ? Math.ceil(i) + "px" : "0px"),
          (t = "top" == o.positionProp ? Math.ceil(i) + "px" : "0px"),
          (s[o.positionProp] = i),
          o.transformsEnabled === !1
            ? o.$slideTrack.css(s)
            : ((s = {}),
              o.cssTransitions === !1
                ? ((s[o.animType] = "translate(" + e + ", " + t + ")"),
                  o.$slideTrack.css(s))
                : ((s[o.animType] = "translate3d(" + e + ", " + t + ", 0px)"),
                  o.$slideTrack.css(s)));
      }),
      (e.prototype.setDimensions = function () {
        var i = this;
        i.options.vertical === !1
          ? i.options.centerMode === !0 &&
            i.$list.css({ padding: "0px " + i.options.centerPadding })
          : (i.$list.height(
              i.$slides.first().outerHeight(!0) * i.options.slidesToShow
            ),
            i.options.centerMode === !0 &&
              i.$list.css({ padding: i.options.centerPadding + " 0px" })),
          (i.listWidth = i.$list.width()),
          (i.listHeight = i.$list.height()),
          i.options.vertical === !1 && i.options.variableWidth === !1
            ? ((i.slideWidth = Math.ceil(i.listWidth / i.options.slidesToShow)),
              i.$slideTrack.width(
                Math.ceil(
                  i.slideWidth * i.$slideTrack.children(".slick-slide").length
                )
              ))
            : i.options.variableWidth === !0
            ? i.$slideTrack.width(5e3 * i.slideCount)
            : ((i.slideWidth = Math.ceil(i.listWidth)),
              i.$slideTrack.height(
                Math.ceil(
                  i.$slides.first().outerHeight(!0) *
                    i.$slideTrack.children(".slick-slide").length
                )
              ));
        var e = i.$slides.first().outerWidth(!0) - i.$slides.first().width();
        i.options.variableWidth === !1 &&
          i.$slideTrack.children(".slick-slide").width(i.slideWidth - e);
      }),
      (e.prototype.setFade = function () {
        var e,
          t = this;
        t.$slides.each(function (o, s) {
          (e = t.slideWidth * o * -1),
            t.options.rtl === !0
              ? i(s).css({
                  position: "relative",
                  right: e,
                  top: 0,
                  zIndex: t.options.zIndex - 2,
                  opacity: 0,
                })
              : i(s).css({
                  position: "relative",
                  left: e,
                  top: 0,
                  zIndex: t.options.zIndex - 2,
                  opacity: 0,
                });
        }),
          t.$slides
            .eq(t.currentSlide)
            .css({ zIndex: t.options.zIndex - 1, opacity: 1 });
      }),
      (e.prototype.setHeight = function () {
        var i = this;
        if (
          1 === i.options.slidesToShow &&
          i.options.adaptiveHeight === !0 &&
          i.options.vertical === !1
        ) {
          var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
          i.$list.css("height", e);
        }
      }),
      (e.prototype.setOption = e.prototype.slickSetOption =
        function () {
          var e,
            t,
            o,
            s,
            n,
            r = this,
            l = !1;
          if (
            ("object" === i.type(arguments[0])
              ? ((o = arguments[0]), (l = arguments[1]), (n = "multiple"))
              : "string" === i.type(arguments[0]) &&
                ((o = arguments[0]),
                (s = arguments[1]),
                (l = arguments[2]),
                "responsive" === arguments[0] &&
                "array" === i.type(arguments[1])
                  ? (n = "responsive")
                  : "undefined" != typeof arguments[1] && (n = "single")),
            "single" === n)
          )
            r.options[o] = s;
          else if ("multiple" === n)
            i.each(o, function (i, e) {
              r.options[i] = e;
            });
          else if ("responsive" === n)
            for (t in s)
              if ("array" !== i.type(r.options.responsive))
                r.options.responsive = [s[t]];
              else {
                for (e = r.options.responsive.length - 1; e >= 0; )
                  r.options.responsive[e].breakpoint === s[t].breakpoint &&
                    r.options.responsive.splice(e, 1),
                    e--;
                r.options.responsive.push(s[t]);
              }
          l && (r.unload(), r.reinit());
        }),
      (e.prototype.setPosition = function () {
        var i = this;
        i.setDimensions(),
          i.setHeight(),
          i.options.fade === !1
            ? i.setCSS(i.getLeft(i.currentSlide))
            : i.setFade(),
          i.$slider.trigger("setPosition", [i]);
      }),
      (e.prototype.setProps = function () {
        var i = this,
          e = document.body.style;
        (i.positionProp = i.options.vertical === !0 ? "top" : "left"),
          "top" === i.positionProp
            ? i.$slider.addClass("slick-vertical")
            : i.$slider.removeClass("slick-vertical"),
          (void 0 === e.WebkitTransition &&
            void 0 === e.MozTransition &&
            void 0 === e.msTransition) ||
            (i.options.useCSS === !0 && (i.cssTransitions = !0)),
          i.options.fade &&
            ("number" == typeof i.options.zIndex
              ? i.options.zIndex < 3 && (i.options.zIndex = 3)
              : (i.options.zIndex = i.defaults.zIndex)),
          void 0 !== e.OTransform &&
            ((i.animType = "OTransform"),
            (i.transformType = "-o-transform"),
            (i.transitionType = "OTransition"),
            void 0 === e.perspectiveProperty &&
              void 0 === e.webkitPerspective &&
              (i.animType = !1)),
          void 0 !== e.MozTransform &&
            ((i.animType = "MozTransform"),
            (i.transformType = "-moz-transform"),
            (i.transitionType = "MozTransition"),
            void 0 === e.perspectiveProperty &&
              void 0 === e.MozPerspective &&
              (i.animType = !1)),
          void 0 !== e.webkitTransform &&
            ((i.animType = "webkitTransform"),
            (i.transformType = "-webkit-transform"),
            (i.transitionType = "webkitTransition"),
            void 0 === e.perspectiveProperty &&
              void 0 === e.webkitPerspective &&
              (i.animType = !1)),
          void 0 !== e.msTransform &&
            ((i.animType = "msTransform"),
            (i.transformType = "-ms-transform"),
            (i.transitionType = "msTransition"),
            void 0 === e.msTransform && (i.animType = !1)),
          void 0 !== e.transform &&
            i.animType !== !1 &&
            ((i.animType = "transform"),
            (i.transformType = "transform"),
            (i.transitionType = "transition")),
          (i.transformsEnabled =
            i.options.useTransform && null !== i.animType && i.animType !== !1);
      }),
      (e.prototype.setSlideClasses = function (i) {
        var e,
          t,
          o,
          s,
          n = this;
        if (
          ((t = n.$slider
            .find(".slick-slide")
            .removeClass("slick-active slick-center slick-current")
            .attr("aria-hidden", "true")),
          n.$slides.eq(i).addClass("slick-current"),
          n.options.centerMode === !0)
        ) {
          var r = n.options.slidesToShow % 2 === 0 ? 1 : 0;
          (e = Math.floor(n.options.slidesToShow / 2)),
            n.options.infinite === !0 &&
              (i >= e && i <= n.slideCount - 1 - e
                ? n.$slides
                    .slice(i - e + r, i + e + 1)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false")
                : ((o = n.options.slidesToShow + i),
                  t
                    .slice(o - e + 1 + r, o + e + 2)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false")),
              0 === i
                ? t
                    .eq(t.length - 1 - n.options.slidesToShow)
                    .addClass("slick-center")
                : i === n.slideCount - 1 &&
                  t.eq(n.options.slidesToShow).addClass("slick-center")),
            n.$slides.eq(i).addClass("slick-center");
        } else
          i >= 0 && i <= n.slideCount - n.options.slidesToShow
            ? n.$slides
                .slice(i, i + n.options.slidesToShow)
                .addClass("slick-active")
                .attr("aria-hidden", "false")
            : t.length <= n.options.slidesToShow
            ? t.addClass("slick-active").attr("aria-hidden", "false")
            : ((s = n.slideCount % n.options.slidesToShow),
              (o = n.options.infinite === !0 ? n.options.slidesToShow + i : i),
              n.options.slidesToShow == n.options.slidesToScroll &&
              n.slideCount - i < n.options.slidesToShow
                ? t
                    .slice(o - (n.options.slidesToShow - s), o + s)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false")
                : t
                    .slice(o, o + n.options.slidesToShow)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false"));
        ("ondemand" !== n.options.lazyLoad &&
          "anticipated" !== n.options.lazyLoad) ||
          n.lazyLoad();
      }),
      (e.prototype.setupInfinite = function () {
        var e,
          t,
          o,
          s = this;
        if (
          (s.options.fade === !0 && (s.options.centerMode = !1),
          s.options.infinite === !0 &&
            s.options.fade === !1 &&
            ((t = null), s.slideCount > s.options.slidesToShow))
        ) {
          for (
            o =
              s.options.centerMode === !0
                ? s.options.slidesToShow + 1
                : s.options.slidesToShow,
              e = s.slideCount;
            e > s.slideCount - o;
            e -= 1
          )
            (t = e - 1),
              i(s.$slides[t])
                .clone(!0)
                .attr("id", "")
                .attr("data-slick-index", t - s.slideCount)
                .prependTo(s.$slideTrack)
                .addClass("slick-cloned");
          for (e = 0; e < o + s.slideCount; e += 1)
            (t = e),
              i(s.$slides[t])
                .clone(!0)
                .attr("id", "")
                .attr("data-slick-index", t + s.slideCount)
                .appendTo(s.$slideTrack)
                .addClass("slick-cloned");
          s.$slideTrack
            .find(".slick-cloned")
            .find("[id]")
            .each(function () {
              i(this).attr("id", "");
            });
        }
      }),
      (e.prototype.interrupt = function (i) {
        var e = this;
        i || e.autoPlay(), (e.interrupted = i);
      }),
      (e.prototype.selectHandler = function (e) {
        var t = this,
          o = i(e.target).is(".slick-slide")
            ? i(e.target)
            : i(e.target).parents(".slick-slide"),
          s = parseInt(o.attr("data-slick-index"));
        return (
          s || (s = 0),
          t.slideCount <= t.options.slidesToShow
            ? void t.slideHandler(s, !1, !0)
            : void t.slideHandler(s)
        );
      }),
      (e.prototype.slideHandler = function (i, e, t) {
        var o,
          s,
          n,
          r,
          l,
          d = null,
          a = this;
        if (
          ((e = e || !1),
          !(
            (a.animating === !0 && a.options.waitForAnimate === !0) ||
            (a.options.fade === !0 && a.currentSlide === i)
          ))
        )
          return (
            e === !1 && a.asNavFor(i),
            (o = i),
            (d = a.getLeft(o)),
            (r = a.getLeft(a.currentSlide)),
            (a.currentLeft = null === a.swipeLeft ? r : a.swipeLeft),
            a.options.infinite === !1 &&
            a.options.centerMode === !1 &&
            (i < 0 || i > a.getDotCount() * a.options.slidesToScroll)
              ? void (
                  a.options.fade === !1 &&
                  ((o = a.currentSlide),
                  t !== !0 && a.slideCount > a.options.slidesToShow
                    ? a.animateSlide(r, function () {
                        a.postSlide(o);
                      })
                    : a.postSlide(o))
                )
              : a.options.infinite === !1 &&
                a.options.centerMode === !0 &&
                (i < 0 || i > a.slideCount - a.options.slidesToScroll)
              ? void (
                  a.options.fade === !1 &&
                  ((o = a.currentSlide),
                  t !== !0 && a.slideCount > a.options.slidesToShow
                    ? a.animateSlide(r, function () {
                        a.postSlide(o);
                      })
                    : a.postSlide(o))
                )
              : (a.options.autoplay && clearInterval(a.autoPlayTimer),
                (s =
                  o < 0
                    ? a.slideCount % a.options.slidesToScroll !== 0
                      ? a.slideCount - (a.slideCount % a.options.slidesToScroll)
                      : a.slideCount + o
                    : o >= a.slideCount
                    ? a.slideCount % a.options.slidesToScroll !== 0
                      ? 0
                      : o - a.slideCount
                    : o),
                (a.animating = !0),
                a.$slider.trigger("beforeChange", [a, a.currentSlide, s]),
                (n = a.currentSlide),
                (a.currentSlide = s),
                a.setSlideClasses(a.currentSlide),
                a.options.asNavFor &&
                  ((l = a.getNavTarget()),
                  (l = l.slick("getSlick")),
                  l.slideCount <= l.options.slidesToShow &&
                    l.setSlideClasses(a.currentSlide)),
                a.updateDots(),
                a.updateArrows(),
                a.options.fade === !0
                  ? (t !== !0
                      ? (a.fadeSlideOut(n),
                        a.fadeSlide(s, function () {
                          a.postSlide(s);
                        }))
                      : a.postSlide(s),
                    void a.animateHeight())
                  : void (t !== !0 && a.slideCount > a.options.slidesToShow
                      ? a.animateSlide(d, function () {
                          a.postSlide(s);
                        })
                      : a.postSlide(s)))
          );
      }),
      (e.prototype.startLoad = function () {
        var i = this;
        i.options.arrows === !0 &&
          i.slideCount > i.options.slidesToShow &&
          (i.$prevArrow.hide(), i.$nextArrow.hide()),
          i.options.dots === !0 &&
            i.slideCount > i.options.slidesToShow &&
            i.$dots.hide(),
          i.$slider.addClass("slick-loading");
      }),
      (e.prototype.swipeDirection = function () {
        var i,
          e,
          t,
          o,
          s = this;
        return (
          (i = s.touchObject.startX - s.touchObject.curX),
          (e = s.touchObject.startY - s.touchObject.curY),
          (t = Math.atan2(e, i)),
          (o = Math.round((180 * t) / Math.PI)),
          o < 0 && (o = 360 - Math.abs(o)),
          o <= 45 && o >= 0
            ? s.options.rtl === !1
              ? "left"
              : "right"
            : o <= 360 && o >= 315
            ? s.options.rtl === !1
              ? "left"
              : "right"
            : o >= 135 && o <= 225
            ? s.options.rtl === !1
              ? "right"
              : "left"
            : s.options.verticalSwiping === !0
            ? o >= 35 && o <= 135
              ? "down"
              : "up"
            : "vertical"
        );
      }),
      (e.prototype.swipeEnd = function (i) {
        var e,
          t,
          o = this;
        if (((o.dragging = !1), (o.swiping = !1), o.scrolling))
          return (o.scrolling = !1), !1;
        if (
          ((o.interrupted = !1),
          (o.shouldClick = !(o.touchObject.swipeLength > 10)),
          void 0 === o.touchObject.curX)
        )
          return !1;
        if (
          (o.touchObject.edgeHit === !0 &&
            o.$slider.trigger("edge", [o, o.swipeDirection()]),
          o.touchObject.swipeLength >= o.touchObject.minSwipe)
        ) {
          switch ((t = o.swipeDirection())) {
            case "left":
            case "down":
              (e = o.options.swipeToSlide
                ? o.checkNavigable(o.currentSlide + o.getSlideCount())
                : o.currentSlide + o.getSlideCount()),
                (o.currentDirection = 0);
              break;
            case "right":
            case "up":
              (e = o.options.swipeToSlide
                ? o.checkNavigable(o.currentSlide - o.getSlideCount())
                : o.currentSlide - o.getSlideCount()),
                (o.currentDirection = 1);
          }
          "vertical" != t &&
            (o.slideHandler(e),
            (o.touchObject = {}),
            o.$slider.trigger("swipe", [o, t]));
        } else
          o.touchObject.startX !== o.touchObject.curX &&
            (o.slideHandler(o.currentSlide), (o.touchObject = {}));
      }),
      (e.prototype.swipeHandler = function (i) {
        var e = this;
        if (
          !(
            e.options.swipe === !1 ||
            ("ontouchend" in document && e.options.swipe === !1) ||
            (e.options.draggable === !1 && i.type.indexOf("mouse") !== -1)
          )
        )
          switch (
            ((e.touchObject.fingerCount =
              i.originalEvent && void 0 !== i.originalEvent.touches
                ? i.originalEvent.touches.length
                : 1),
            (e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold),
            e.options.verticalSwiping === !0 &&
              (e.touchObject.minSwipe =
                e.listHeight / e.options.touchThreshold),
            i.data.action)
          ) {
            case "start":
              e.swipeStart(i);
              break;
            case "move":
              e.swipeMove(i);
              break;
            case "end":
              e.swipeEnd(i);
          }
      }),
      (e.prototype.swipeMove = function (i) {
        var e,
          t,
          o,
          s,
          n,
          r,
          l = this;
        return (
          (n = void 0 !== i.originalEvent ? i.originalEvent.touches : null),
          !(!l.dragging || l.scrolling || (n && 1 !== n.length)) &&
            ((e = l.getLeft(l.currentSlide)),
            (l.touchObject.curX = void 0 !== n ? n[0].pageX : i.clientX),
            (l.touchObject.curY = void 0 !== n ? n[0].pageY : i.clientY),
            (l.touchObject.swipeLength = Math.round(
              Math.sqrt(Math.pow(l.touchObject.curX - l.touchObject.startX, 2))
            )),
            (r = Math.round(
              Math.sqrt(Math.pow(l.touchObject.curY - l.touchObject.startY, 2))
            )),
            !l.options.verticalSwiping && !l.swiping && r > 4
              ? ((l.scrolling = !0), !1)
              : (l.options.verticalSwiping === !0 &&
                  (l.touchObject.swipeLength = r),
                (t = l.swipeDirection()),
                void 0 !== i.originalEvent &&
                  l.touchObject.swipeLength > 4 &&
                  ((l.swiping = !0), i.preventDefault()),
                (s =
                  (l.options.rtl === !1 ? 1 : -1) *
                  (l.touchObject.curX > l.touchObject.startX ? 1 : -1)),
                l.options.verticalSwiping === !0 &&
                  (s = l.touchObject.curY > l.touchObject.startY ? 1 : -1),
                (o = l.touchObject.swipeLength),
                (l.touchObject.edgeHit = !1),
                l.options.infinite === !1 &&
                  ((0 === l.currentSlide && "right" === t) ||
                    (l.currentSlide >= l.getDotCount() && "left" === t)) &&
                  ((o = l.touchObject.swipeLength * l.options.edgeFriction),
                  (l.touchObject.edgeHit = !0)),
                l.options.vertical === !1
                  ? (l.swipeLeft = e + o * s)
                  : (l.swipeLeft =
                      e + o * (l.$list.height() / l.listWidth) * s),
                l.options.verticalSwiping === !0 && (l.swipeLeft = e + o * s),
                l.options.fade !== !0 &&
                  l.options.touchMove !== !1 &&
                  (l.animating === !0
                    ? ((l.swipeLeft = null), !1)
                    : void l.setCSS(l.swipeLeft))))
        );
      }),
      (e.prototype.swipeStart = function (i) {
        var e,
          t = this;
        return (
          (t.interrupted = !0),
          1 !== t.touchObject.fingerCount ||
          t.slideCount <= t.options.slidesToShow
            ? ((t.touchObject = {}), !1)
            : (void 0 !== i.originalEvent &&
                void 0 !== i.originalEvent.touches &&
                (e = i.originalEvent.touches[0]),
              (t.touchObject.startX = t.touchObject.curX =
                void 0 !== e ? e.pageX : i.clientX),
              (t.touchObject.startY = t.touchObject.curY =
                void 0 !== e ? e.pageY : i.clientY),
              void (t.dragging = !0))
        );
      }),
      (e.prototype.unfilterSlides = e.prototype.slickUnfilter =
        function () {
          var i = this;
          null !== i.$slidesCache &&
            (i.unload(),
            i.$slideTrack.children(this.options.slide).detach(),
            i.$slidesCache.appendTo(i.$slideTrack),
            i.reinit());
        }),
      (e.prototype.unload = function () {
        var e = this;
        i(".slick-cloned", e.$slider).remove(),
          e.$dots && e.$dots.remove(),
          e.$prevArrow &&
            e.htmlExpr.test(e.options.prevArrow) &&
            e.$prevArrow.remove(),
          e.$nextArrow &&
            e.htmlExpr.test(e.options.nextArrow) &&
            e.$nextArrow.remove(),
          e.$slides
            .removeClass("slick-slide slick-active slick-visible slick-current")
            .attr("aria-hidden", "true")
            .css("width", "");
      }),
      (e.prototype.unslick = function (i) {
        var e = this;
        e.$slider.trigger("unslick", [e, i]), e.destroy();
      }),
      (e.prototype.updateArrows = function () {
        var i,
          e = this;
        (i = Math.floor(e.options.slidesToShow / 2)),
          e.options.arrows === !0 &&
            e.slideCount > e.options.slidesToShow &&
            !e.options.infinite &&
            (e.$prevArrow
              .removeClass("slick-disabled")
              .attr("aria-disabled", "false"),
            e.$nextArrow
              .removeClass("slick-disabled")
              .attr("aria-disabled", "false"),
            0 === e.currentSlide
              ? (e.$prevArrow
                  .addClass("slick-disabled")
                  .attr("aria-disabled", "true"),
                e.$nextArrow
                  .removeClass("slick-disabled")
                  .attr("aria-disabled", "false"))
              : e.currentSlide >= e.slideCount - e.options.slidesToShow &&
                e.options.centerMode === !1
              ? (e.$nextArrow
                  .addClass("slick-disabled")
                  .attr("aria-disabled", "true"),
                e.$prevArrow
                  .removeClass("slick-disabled")
                  .attr("aria-disabled", "false"))
              : e.currentSlide >= e.slideCount - 1 &&
                e.options.centerMode === !0 &&
                (e.$nextArrow
                  .addClass("slick-disabled")
                  .attr("aria-disabled", "true"),
                e.$prevArrow
                  .removeClass("slick-disabled")
                  .attr("aria-disabled", "false")));
      }),
      (e.prototype.updateDots = function () {
        var i = this;
        null !== i.$dots &&
          (i.$dots.find("li").removeClass("slick-active").end(),
          i.$dots
            .find("li")
            .eq(Math.floor(i.currentSlide / i.options.slidesToScroll))
            .addClass("slick-active"));
      }),
      (e.prototype.visibility = function () {
        var i = this;
        i.options.autoplay &&
          (document[i.hidden] ? (i.interrupted = !0) : (i.interrupted = !1));
      }),
      (i.fn.slick = function () {
        var i,
          t,
          o = this,
          s = arguments[0],
          n = Array.prototype.slice.call(arguments, 1),
          r = o.length;
        for (i = 0; i < r; i++)
          if (
            ("object" == typeof s || "undefined" == typeof s
              ? (o[i].slick = new e(o[i], s))
              : (t = o[i].slick[s].apply(o[i].slick, n)),
            "undefined" != typeof t)
          )
            return t;
        return o;
      });
  });

  // String Fuzzy Match Prototype
  String.prototype.fuzzy = function (s) {
    var hay = this.toLowerCase(),
      i = 0,
      n = -1,
      l;
    s = s.toLowerCase();
    for (; (l = s[i++]); ) if (!~(n = hay.indexOf(l, n + 1))) return false;
    return true;
  };

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, "");
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === "master") {
      return removeProtocol(src);
    }

    const match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match) {
      const prefix = src.split(match[0]);
      const suffix = match[0];

      return removeProtocol(`${prefix[0]}_${size}${suffix}`);
    } else {
      return src;
    }
  }

  const defaultEngravingOptions = {
    price: 0,
    location: null,
    lettering: ["capitalized", "uppercase", "lowercase"],
    styles: ["formal", "simple", "modern", "script", "elegant"],
  };

  const engravingDisclaimers = {
    graphic:
      "Engrave an image, logo, fingerprint or crest on your piece. We will email you shortly after completing your order to submit your graphic file",
    handwritten:
      "Engrave your own handwriting on your piece. We will email you shortly after completing your order to submit your handwritten image. <br /> (NOTE: All handwritten engraving images must be on a solid white background or a file with a transparent background.)",
  };

  var createId = function () {
    // Math.random should be unique because of its seeding algorithm.
    // Convert it to base 36 (numbers + letters), and grab the first 9 characters
    // after the decimal.
    return "_" + Math.random().toString(36).substr(2, 9);
  };

  const intersection = (a, b) => {
    const s = new Set(b);
    return [...new Set(a)].filter((x) => s.has(x));
  };

  const arrayOfLength = (n) => {
    const arr = new Array(n);

    for (let i = 0; i < arr.length; i++) {
      arr[i] = i + 1;
    }

    return arr;
  };

  Handlebars.registerHelper("humanize", function (options) {
    var i,
      frags = options.fn(this).split("-");
    for (i = 0; i < frags.length; i++) {
      frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
    }

    return frags.join(" ");
  });

  const Addons = {
    addonHTML(addons) {
      function addonsHTML(addon, index) {
        const options = addon.product.options;
        const addonKey = createId();

        const optionHTML = options.map(function (option, index) {
          return `
                    <div class="infinite-selector-wrapper addon-select-wrapper" data-id="infinite-select-option-${addonKey}">
                      <span class="selectArrow"></span>
                      <label for="infinite-select-option-${index}">${option.name}</label>
                      <select id="infinite-select-option-${index}" data-product="${addon.product.handle}" data-position="${option.position}" name="properties[${addon.title}]" data-option="infinite${addonKey}" class="addon-selector single-option-selector">
                        <option value="_none">NO ${option.name.toUpperCase()}</option>  
                        ${option.values
                          .map(function (value) {
                            return `
                             <option value="${value}">${value.toUpperCase()}</option>
                            `;
                          })
                          .join("")}
                      </select>
                    </div>         
                    `;
        });

        return optionHTML;

        return `
                <div class="infinite-selector-wrapper addon-select-wrapper" data-id="infinite-select-option-${index}">
                  <span class="selectArrow"></span>
                  <label for="infinite-select-option-${index}">${
          addon.title
        }</label>
                  <select id="infinite-select-option-${index}" data-product="${
          addon.product.handle
        }" name="properties[${
          addon.title
        }]" data-option="infinite${index}" class="addon-selector single-option-selector">
                    <option value="_none">NO ${addon.title.toUpperCase()}</option>  
                    ${addon.product.variants
                      .map(function (variant) {
                        return `
                         <option value="${variant.title}">${variant.title}</option>
                        `;
                      })
                      .join("")}
                  </select>
                </div>                
                `;
      }

      const $formOptions = document.querySelector(
        ".productForm-block.productForm-block--options-inline"
      );
      const currentCount = $formOptions.getAttribute("data-options");
      const variantHTML = [...addons].map(addonsHTML);

      $formOptions.setAttribute(
        "data-options",
        Number(currentCount) + addons.length
      );

      // console.log('Addon HTML?', addons, this.state.addons, variantHTML, $formOptions);
      const $infiniteOptions = $formOptions.querySelector(
        "#infiniteoptions-container"
      );

      // Instead of updating all html, we will insert before the infinite options.
      variantHTML
        .reduce((final, each) => final.concat(each), [])
        .forEach((html) => {
          const $hWrapper = document.createElement("div");
          $hWrapper.innerHTML = html;
          // console.log('H Wrapper', $hWrapper, $hWrapper.children[0]);
          $formOptions.insertBefore($hWrapper.children[0], $infiniteOptions);
        });

      // $formOptions.innerHTML += variantHTML;
    },
    addonCarousels(addons) {
      const addonKey = createId();
      const $formOptions = document.querySelector(
        ".productForm-block.productForm-block--options-inline"
      );

      const carouselsHTML = [...addons]
        .map((addon) => {
          const products = addon.collection;
          const addonKey = createId();

          return `
                <div class="addon-carousel-wrapper" id="addon-${addon.id}" ${
            addon.union ? 'style="display: none;"' : ""
          }>
                    <h4>${addon.title}</h4>
                    <ul class="addon-carousel">
                    ${[...products]
                      .map((product) => {
                        return `
                        <li class="addon-carousel-item">
                            <input data-option="${addonKey}" type="radio" data-addon="${addon.tag}" class="addon-radios" id="addon-item-${product.handle}" data-price="${product.variants[0].price}" value="${product.variants[0].id}" name="properties[${addon.title}]" />
                            <label for="addon-item-${product.handle}">
                              <img src="${product.featured_image}" />
                              <span>${product.title}</span>
                            </label>
                        </li>
                        `;
                      })
                      .join("")}
                    </ul>
                </div>
                `;
        })
        .join("");

      $formOptions.innerHTML += carouselsHTML;

      setTimeout(function () {
        $(".addon-carousel:not(.slick-initialized)").slick({
          slidesToShow: 3,
          draggable: true,
          infinite: false,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
              },
            },
          ],
        });
      }, 250);
      console.warn("Addon Carousels", addons);
    },
    addonGemstones(addon, returnHtml) {
      if (!addon) return;

      document.querySelector(
        ".pdp-customizations-child.gemstonebtn"
      ).style.display = "block";
      console.warn("GEMSTONE ADDONS", addon);

      const tag = addon.tag.split("|");
      tag.shift();

      const settings = tag.reduce(
        function (settings, tagSetting) {
          let [key, values] = tagSetting.split(":");

          key = key.trim();
          values = values.trim();

          if (key === "location") {
            let locations = values.trim().split("_");
            settings[key] = locations;
          }

          if (key === "max") {
            let max = Number(values.trim()) || -1;
            settings[key] = max;
          }

          return settings;
        },
        {
          location: ["standard"],
          max: 1,
        }
      );

      function attachListeners() {
        $(document).on(
          "change",
          ".gemstone-select, .gemstone-property-select",
          function (event) {
            const $select = event.target;
            const optionName = $select.getAttribute("data-option");
            const allSelects = document.querySelectorAll(
              `.gemstone-select[data-option="${optionName}"]`
            );
            const $propertySelects = document.querySelectorAll(
              `.gemstone-property-select[data-option="${optionName}"]`
            );
            const selectsAsOptions = [...allSelects].reduce(
              function (options, $select) {
                const position = $select.getAttribute("data-position");
                const key = `option${position}`;

                options[key] = $select.value;

                return options;
              },
              {
                option1: null,
                option2: null,
                option3: null,
              }
            );

            const variant = addon.product.variants.find(function (variant) {
              return Object.keys(selectsAsOptions).every(function (key) {
                return variant[key] === selectsAsOptions[key];
              });
            });
            // console.log('Change Gemstone', variant);

            if (variant) {
              variant.properties = {};

              [...$propertySelects].forEach(function ($select) {
                const property = $select.getAttribute("data-property");

                variant.properties[property] = $select.value;
              });
            }

            $self.state.selected[optionName] = variant;
            $self.updateAddonPricing();
          }
        );

        $(document).on("click", ".remove-gemstone", function (event) {
          const $removeBtn = event.target;
          const $container = $removeBtn.parentElement;
          const $select = $container.querySelector(".gemstone-select");
          const optionName = $select.getAttribute("data-option");

          delete $self.state.selected[optionName];
          $container.parentElement.removeChild($container);

          // console.log('Remove Gemstone', event.target);
        });

        $(document).on("click", ".add-new-gemstone", function (event) {
          const $btn = event.currentTarget;
          const currentGemstoneCount = document.querySelectorAll(
            ".gemstone-component"
          ).length;
          const newGemstoneHtml = addGemstoneComponent(
            false,
            currentGemstoneCount + 1
          );
          const tempWrapper = document.createElement("div");
          tempWrapper.innerHTML = newGemstoneHtml;

          const component = tempWrapper.querySelector(".gemstone-component");

          $btn.parentElement.insertBefore(component, $btn);

          // console.log('Btn click', $btn, settings, settings.max, currentGemstoneCount+1);

          if (currentGemstoneCount + 1 == settings.max) {
            $btn.style.display = "none";
          }
        });
      }

      function addGemstoneComponent(button, index = "") {
        const gemstoneKey = createId();

        return `
                 <div class="gemstone-component" data-key="${gemstoneKey}">
                    <h4>Gemstone ${index}</h4>
                    <button type="button" class="remove-gemstone">X</button>
                    <div class="options-wrapper">
                        ${addon.product.options
                          .map(function (option, index) {
                            return `
                            <div data-gemstone class="infinite-selector-wrapper addon-select-wrapper" data-id="infinite-select-option-${gemstoneKey}">
                                <label>${option.name}</label>
                                <div class="custom-select-wrapper" style="height: 50px;">                                
                                    <select id="infinite-select-option-${gemstoneKey}-${index}" data-product="${addon.product.handle}" data-position="${option.position}" name="properties[${addon.title}]" data-option="infinite${gemstoneKey}" class="gemstone-selector single-option-selector gemstone-select">
                                        <option value="_none">NO ${option.name.toUpperCase()}</option>  
                                        ${option.values
                                          .map(function (value) {
                                            return `
                                            <option value="${value}">${value.toUpperCase()}</option>
                                            `;
                                          })
                                          .join("")}
                                    </select>
                                    <custom-select  data-product="${
                                      addon.product.handle
                                    }" data-position="${option.position}" name="properties[${addon.title}]" data-option="infinite${gemstoneKey}" class="gemstone-select selectCustom js-selectCustom infinite-select-option-${gemstoneKey}" aria-hidden="true">
                                        <div class="selectCustom-trigger">Select ${
                                          option.name
                                        }</div>

                                        <div class="selectCustom-options">
                                        ${[...option.values]
                                          .map((value) => {
                                            const $wrapper =
                                              document.createElement("div");

                                            $wrapper.setAttribute(
                                              "data-value",
                                              value
                                            );
                                            $wrapper.textContent = value;

                                            $wrapper.classList.add(
                                              "dropdown-option"
                                            );

                                            const $container =
                                              document.createElement("div");
                                            $container.appendChild($wrapper);

                                            return $container.innerHTML;
                                          })
                                          .join("")}
                                        </div>
                                    </custom-select>
                                </div>
                            </div>     
                            `;
                          })
                          .join("")}

                        <div class="infinite-selector-wrapper addon-select-wrapper" data-id="infinite-select-option-${gemstoneKey}">
                            <label>Location</label>
                            <div class="custom-select-wrapper" style="height: 50px;">
                                <select id="infinite-select-option-${gemstoneKey}" data-product="${
          addon.product.handle
        }" data-property="Location" name="properties[Gemstone Location]" data-option="infinite${gemstoneKey}"  class="gemstone-selector gemstone-property-select single-option-selector">
                                    ${settings.location
                                      .map(function (location) {
                                        return `
                                        <option value="${location}">${location.toUpperCase()}</option>
                                        `;
                                      })
                                      .join("")}
                                </select>
                                <custom-select  data-product="${
                                  addon.product.handle
                                }" data-product="${
          addon.product.handle
        }" data-property="Location" name="properties[Gemstone Location]" data-option="infinite${gemstoneKey}"  class="gemstone-select selectCustom js-selectCustom infinite-select-option-${gemstoneKey}" aria-hidden="true">
                                    <div class="selectCustom-trigger">Select Location</div>

                                    <div class="selectCustom-options">
                                    ${settings.location
                                      .map(function (location) {
                                        return `
                                        <option value="${location}">${location.toUpperCase()}</option>
                                        `;
                                      })
                                      .join("")}
                                    </div>
                                </custom-select>
                            </div>
                        </div>    
                    </div>
                 </div>

                 ${
                   button
                     ? `
                 <div class="gemstone-actions-wrapper">
                   <button type="button" class="add-new-gemstone">Add Gemstone</button>
                 </div>
                 `
                     : ""
                 }
                `;
      }

      function createNumArray(n = 0) {
        let arr = new Array(n);
        for (var i = 0; i < arr.length; i++) {
          arr[i] = i;
        }

        return arr;
      }

      // console.log('Gemstone Settings', settings);

      const $formOptions = document.querySelector(
        ".productForm-block.productForm-block--options-inline"
      );
      const $self = this;

      console.log("GEMSTONE FORM:", $formOptions);
      if (returnHtml) {
        const $html = `
                    ${
                      settings.max === -1
                        ? addGemstoneComponent(true)
                        : addGemstoneComponent(true)
                      //  createNumArray(settings.max).map((i) => addGemstoneComponent(false)).join('')
                    }
                `;

        attachListeners();

        return $html;
      } else {
        $formOptions.parentElement.parentElement.querySelector(
          ".gemstone-container"
        ).innerHTML += `
                  ${
                    settings.max === -1
                      ? addGemstoneComponent(true)
                      : addGemstoneComponent(true)
                    //  createNumArray(settings.max).map((i) => addGemstoneComponent(false)).join('')
                  }
                `;
      }

      $(document).on(
        "change",
        ".gemstone-select, .gemstone-property-select",
        function (event) {
          const $select = event.target;
          const optionName = $select.getAttribute("data-option");
          const allSelects = document.querySelectorAll(
            `.gemstone-select[data-option="${optionName}"]`
          );
          const $propertySelects = document.querySelectorAll(
            `.gemstone-property-select[data-option="${optionName}"]`
          );
          const selectsAsOptions = [...allSelects].reduce(
            function (options, $select) {
              const position = $select.getAttribute("data-position");
              const key = `option${position}`;

              options[key] = $select.value;

              return options;
            },
            {
              option1: null,
              option2: null,
              option3: null,
            }
          );

          const variant = addon.product.variants.find(function (variant) {
            return Object.keys(selectsAsOptions).every(function (key) {
              return variant[key] === selectsAsOptions[key];
            });
          });
          // console.log('Change Gemstone', variant);

          if (variant) {
            variant.properties = {};

            [...$propertySelects].forEach(function ($select) {
              const property = $select.getAttribute("data-property");

              variant.properties[property] = $select.value;
            });
          }

          $self.state.selected[optionName] = variant;
          $self.updateAddonPricing();
        }
      );

      $(document).on("click", ".remove-gemstone", function (event) {
        const $removeBtn = event.target;
        const $container = $removeBtn.parentElement;
        const $select = $container.querySelector(".gemstone-select");
        const optionName = $select.getAttribute("data-option");

        delete $self.state.selected[optionName];
        $container.parentElement.removeChild($container);

        // console.log('Remove Gemstone', event.target);
      });

      $(document).on("click", ".add-new-gemstone", function (event) {
        const $btn = event.currentTarget;
        const currentGemstoneCount = document.querySelectorAll(
          ".gemstone-component"
        ).length;
        const newGemstoneHtml = addGemstoneComponent(
          false,
          currentGemstoneCount + 1
        );
        const tempWrapper = document.createElement("div");
        tempWrapper.innerHTML = newGemstoneHtml;

        const component = tempWrapper.querySelector(".gemstone-component");

        $btn.parentElement.insertBefore(component, $btn);

        // console.log('Btn click', $btn, settings, settings.max, currentGemstoneCount+1);

        if (currentGemstoneCount + 1 == settings.max) {
          $btn.style.display = "none";
        }
      });

      setTimeout(function () {
        $(".gemstone-select, .gemstone-property-select").trigger("change");
      }, 750);
      // console.log('Trigger Change');
    },
    async buildAddonOptions(addon, $wrapper, infiniteOption) {
      const $self = this;
      const $currentOptions = $wrapper.querySelector(".add-options-wrapper");

      if ($currentOptions) $wrapper.removeChild($currentOptions);

      console.warn("Build Addon Options", { addon, $wrapper, $self });
      const $title = $wrapper.querySelector("h4");

      const additionalAddons = await PDP.initializeAddons(addon);
      const additionalOptions = await PDP.loadInfiniteOptions(addon);
      const engravingAddon = await PDP.engravingEngine(addon);
      let addonhtml = "";

      console.log("Additional Addons?", {
        additionalAddons,
        additionalOptions,
        engravingAddon,
        $self,
      });

      if (additionalAddons && additionalAddons.length > 0) {
        // console.log('Prior Setup', this.state);
        let noChainsCharms = additionalAddons.filter((addon) => {
          return !/(chain|charm)/gi.test(addon.tag);
        });

        let currentAddons = this.state.addons || [];

        const addonBreakdown = this.start(
          [...currentAddons, ...noChainsCharms],
          true
        );

        let gemstoneHTML =
          addonBreakdown.gemstoneAddons.length > 0
            ? this.addonGemstones(addonBreakdown.gemstoneAddons[0], true)
            : "";

        addonhtml += gemstoneHTML;
        // console.log('Addon Breakdown', addonBreakdown, gemstoneHTML);
      }

      const $optionsWrapper = document.createElement("div");

      $optionsWrapper.classList.add("add-options-wrapper");
      $optionsWrapper.innerHTML = `
                <h4>${$title.textContent.trim()} OPTIONS</h4>
                <div class="variant-options-table">
                    <div data-options="${
                      addon.options.length
                    }" class="productForm-block productForm-block--options-inline ">
                        ${[...addon.options]
                          .map(
                            (option, index) => `
                        <div class="infinite-selector-wrapper" data-id="infinite-select-option-${index}-${
                              addon.handle
                            }">
                            <span class="selectArrow"></span>
                            <label for="infinite-select-option-${index}-${
                              addon.handle
                            }">${option.name}</label>
                            <select id="infinite-select-option-${index}-${
                              addon.handle
                            }" data-option-index="${
                              index + 1
                            }" data-option="infinite${index}-${
                              addon.handle
                            }" class="single-option-selector">
                            ${option.values
                              .map(function (value) {
                                return `
                                <option value='${value}'>${value}</option>
                                `;
                              })
                              .join("")}
                            </select>
                        </div>
                        `
                          )
                          .join("")}

                        ${additionalOptions ? additionalOptions.optionHTML : ""}
                    </div>
                    ${addonhtml}
                    ${
                      engravingAddon
                        ? `
                    <div class="engraving-wrapper" style="padding-top: 15px;">
                        <p class="label">PERSONALIZATION</p>
                        <button type="button" class="engraving-trigger">CLICK HERE TO ADD YOUR ENGRAVING</button>
                    </div>
                    `
                        : ""
                    }
                </div>
                
            `;

      $wrapper.appendChild($optionsWrapper);

      console.log(
        "Addons Wrapper",
        $wrapper.querySelector(".birthstones-wrapper")
      );

      const $selects = $optionsWrapper.querySelectorAll("select");
      const $textInputs =
        $optionsWrapper.querySelectorAll('input[type="text"]');

      function selectChangeHandler(event) {
        const $select = event.target;
        const optionIndex = $select.getAttribute("data-option-index");
        const selectedOptions = [...$selects].reduce(
          (options, $optionSelect) => {
            const selectedOption =
              $optionSelect.getAttribute("data-option-index");

            options[`option${selectedOption}`] = $optionSelect.value;

            return options;
          },
          {}
        );

        const variant = addon.variants.find((variant) => {
          return Object.keys(selectedOptions).every((optionKey) => {
            return selectedOptions[optionKey] === variant[optionKey];
          });
        });

        // console.log('Select Change', selectedOptions, addon.variants);

        $self.state.selected[infiniteOption] = {
          id: variant.id,
          price: variant.price,
        };
        $self.updateAddonPricing();

        // console.log('Index Changed', optionIndex, selectedOptions, variant);
      }

      function textInputChangeHandler(event) {
        const $target = event.target;
        const name = $target.name;
        const property = name.match(/\[(.*)\]/).pop();
        // console.log('Text Changed', event.target.value, property);

        $self.state.selected[infiniteOption].properties =
          $self.state.selected[infiniteOption].properties || {};
        $self.state.selected[infiniteOption] = {
          ...$self.state.selected[infiniteOption],
          properties: {
            [property]: $target.value,
          },
        };
      }

      console.log("Text Inputs:", $textInputs);
      [...$textInputs].forEach(($input) =>
        $input.addEventListener("change", textInputChangeHandler)
      );
      [...$selects].forEach(($select) =>
        $select.addEventListener("change", selectChangeHandler)
      );

      // console.log('All $selects', $selects);
    },
    eventListeners() {
      const $self = this;
      const $selects = document.querySelectorAll(".addon-selector");
      const $radios = document.querySelectorAll(".addon-radios");

      // console.log('Event Listener Self?', $self);
      function selectHandler(event) {
        const $select = event.target;
        const handle = $select.getAttribute("data-product");
        const addon = $self.state.addons.find(
          (addon) => addon.product.handle === handle
        );
        const infiniteOption = $select.getAttribute("data-option");
        const $allOptionSelectors = document.querySelectorAll(
          `select[data-option="${infiniteOption}"]`
        );

        const optionsSelected = [...$allOptionSelectors].reduce(function (
          options,
          $select
        ) {
          const position = $select.getAttribute("data-position");
          const key = `option${position}`;

          options[key] = $select.value;

          return options;
        },
        {});

        const variant = addon.product.variants.find(function (variant) {
          return Object.keys(optionsSelected).every(function (key) {
            return variant[key] === optionsSelected[key];
          });
        });

        $self.state.selected[infiniteOption] = variant;
        $self.updateAddonPricing();
      }

      function radioHandler(event) {
        const $input = event.target;
        const id = $input.value;
        const price = Number($input.getAttribute("data-price"));
        const infiniteOption = $input.getAttribute("data-option");
        const addonTag = $input.getAttribute("data-addon");
        const addonSettings = $self.state.addons.find(
          (addon) => addon.tag === addonTag
        );

        // console.log('Addon Settings', { addonSettings, addonTag, $self });

        if (addonSettings) {
          const addon =
            addonSettings.product ||
            addonSettings.collection.find(
              (product) => product.variants[0].id == id
            );
          $self.state.selected[infiniteOption] = { id, price };
          $self.buildAddonOptions(
            addon,
            $input.closest(".addon-carousel-wrapper"),
            infiniteOption
          );
          $self.addons = addon;
        } else {
          if (document.querySelector(".add-options-wrapper")) {
            document
              .querySelector(".add-options-wrapper")
              .parentElement.removeChild(
                document.querySelector(".add-options-wrapper")
              );
          }
        }

        $self.updateAddonPricing();
        // console.log('Radio Change', $self, addonTag, addonSettings, id);
      }

      $selects.forEach(($select) =>
        $select.addEventListener("change", selectHandler)
      );
      $radios.forEach(($radio) =>
        $radio.addEventListener("change", radioHandler)
      );
      $radios.forEach(($radio) =>
        $radio.nextElementSibling.addEventListener("touchstart", function () {
          // console.log('Click', $radio.nextElementSibling);
          $($radio.nextElementSibling).click();
        })
      );
      // console.log('Addon Selects', $selects);
    },
    state: {
      addons: null,
      selected: {},
    },
    start(addons, additionalSet) {
      // console.log('Start!', {addons}, this.state.addons);
      this.state.addons = addons;

      // no gemstones int he dropdown addons
      const dropdownAddons = addons.filter(
        (addon) => !addon.collection && !addon.tag.includes("gemstone")
      );
      const gemstoneAddons = addons.filter(
        (addon) => !addon.collection && addon.tag.includes("gemstone")
      );
      const carouselAddons = addons.filter((addon) =>
        Boolean(addon.collection)
      );

      if (additionalSet) {
        return {
          dropdownAddons,
          gemstoneAddons,
          carouselAddons,
        };
      }

      this.addonHTML(dropdownAddons);
      this.addonCarousels(carouselAddons);
      this.addonGemstones(gemstoneAddons[0]);

      this.eventListeners();

      window.addon_state = this.state;
    },
    unionStart(unions) {
      const $self = this;

      function unionHtml(union) {
        const $wrapper = document.createElement("div");

        $wrapper.classList.add("addon-union-wrapper");

        const html = `
                    <h4>${union.title}</h4>
                    <ul class="union-options-list">
                     ${
                       union.allow_none
                         ? `
                        <li>
                          <input id="union-${union.id}" type="radio" name="${
                             union.id
                           }" value="_none" checked />
                          <label for="union-${
                            union.id
                          }">No ${union.title.replace(/option/gi, "")}</label>
                        </li>
                     `
                         : ""
                     }
                     ${[...union.addons]
                       .map(
                         (addon) => `
                        <li>
                          <input id="union-${addon.id}" type="radio" name="${union.id}" value="${addon.id}" />
                          <label for="union-${addon.id}">${addon.title}</label>
                        </li>
                     `
                       )
                       .join("")}
                    </ul>
                `;

        $wrapper.innerHTML = html;

        return $wrapper;
      }

      [...unions].forEach((union) => {
        const $container = unionHtml(union);
        const addonIds = union.addons.map((item) => `#addon-${item.id}`);
        const $addon = document.querySelector(addonIds.join(","));

        // console.log('Addon Container', $addon, { union });

        if ($addon) {
          // console.log('Appending', $addon, $addon.parentElement, $container);

          $addon.parentElement.insertBefore($container, $addon);
        }
      });

      function radioHandler(event) {
        const $radio = event.target;
        const value = $radio.value;
        const name = $radio.name;
        const allAddons = [
          ...document.querySelectorAll(`input[name="${name}"]`),
        ].map(($input) => $input.value);
        const $unionWrapper = document.querySelector(".addon-union-wrapper");
        const $checkedInput = $unionWrapper.parentElement.querySelector(
          ".addon-carousel-wrapper input:checked"
        );
        // const $checkedInput = $addonWrapper.querySelector('input:checked');

        if ($checkedInput) {
          const key = $checkedInput.getAttribute("data-option");

          $checkedInput.checked = false;
          delete $self.state.selected[key];
        }

        // if(value === '_none') {
        //     const $unionWrapper = document.querySelector('.addon-union-wrapper');
        //     const $checkedInput = $unionWrapper.parentElement.querySelector('.addon-carousel-wrapper input:checked');
        //     // const $checkedInput = $addonWrapper.querySelector('input:checked');

        //     if($checkedInput) {
        //         const key = $checkedInput.getAttribute('data-option');

        //         $checkedInput.checked = false;
        //         delete $self.state.selected[key];
        //     }
        // }

        // console.log('Radio Change', { value, allAddons });
        [...allAddons].forEach((id) => {
          const $addon = document.querySelector(`#addon-${id}`);

          if ($addon) {
            $addon.style.display = id === value ? "flex" : "none";

            if ($addon.querySelector(".addon-carousel")) {
              $($addon.querySelector(".addon-carousel")).slick("reinit");
            }
          }
        });
      }

      [...document.querySelectorAll(".union-options-list input")].forEach(
        ($radio) => {
          $radio.addEventListener("change", radioHandler);
        }
      );
      // console.log('Start Unions', {unions});
    },
    updateAddonPricing() {
      const selectedAddons = this.state.selected;
      const $priceWrapper = document.querySelector(
        ".product-title__wrapper .product-price"
      );
      const defaultPrice = Number($priceWrapper.getAttribute("data-price"));

      const $price =
        $priceWrapper.querySelector(
          '.product-normal-price[itemprop="price"]'
        ) || $priceWrapper;

      // console.log('Update Price', defaultPrice, selectedAddons);

      const totalPrice = Object.keys(selectedAddons).reduce((total, key) => {
        const variant = selectedAddons[key];

        const price = variant ? variant.price : 0;

        total += price;

        return total;
      }, defaultPrice);

      $price.textContent = Shopify.formatMoney(
        totalPrice,
        Shopify.money_format
      );

      // console.log('Selected Addons', $price, totalPrice, selectedAddons, defaultPrice);
    },
    async submitHandler(key) {
      const $keyInput = document.getElementById("mainKey");

      const mainKey = key;

      const actives = Object.keys(this.state.selected)
        .filter((key) => Boolean(this.state.selected[key]))
        .map((key) => {
          const properties = this.state.selected[key].properties || {};

          return {
            id: this.state.selected[key].id,
            quantity: 1,
            properties: {
              _main: mainKey,
              type: "addon",
              ...properties,
            },
          };
        });

      if (actives.length === 0) return;

      // console.log('ACTIVES', actives);

      const adding = {
        items: actives,
      };

      const options = {
        body: JSON.stringify(adding),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With":
            "xmlhttprequest" /* XMLHttpRequest is ok too, it's case insensitive */,
        },
        method: "POST",
      };

      const added = await fetch("/cart/add.js", options)
        .then((res) => res.json())
        .then((err) => err);

      // console.log('Addon Result', added);

      // const cart = await PDP.fetchCart();
      window.AjaxCart.getCart(window.AjaxCart.buildCart);
    },
  };

  const Engraving = {
    addEngraving() {
      const properties = {
        capitalization:
          this.state.capitalization == ""
            ? document.getElementById("engraving-lettering").value
            : this.state.capitalization,
        location:
          this.state.location == "" &&
          document.getElementById("engraving-location")
            ? document.getElementById("engraving-location").value
            : this.state.location,
        personalization: this.state.personalization,
        personalization2: this.state.personalization2,
        style: this.state.style,
        main: this.main_product.title,
      };

      if (!properties.capitalization) {
        delete properties.capitalization;
      }

      if (!properties.location) {
        delete properties.location;
      }

      if (!properties.personalization) {
        delete properties.personalization;
      }
      // console.log('Engraving Properties', properties);

      const adding = {
        items: [
          {
            id: this.state.variant.id,
            quantity: 1,
            properties,
          },
        ],
      };

      const options = {
        body: JSON.stringify(adding),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With":
            "xmlhttprequest" /* XMLHttpRequest is ok too, it's case insensitive */,
        },
        method: "POST",
      };

      return fetch("/cart/add.js", options)
        .then((res) => res.json())
        .then((error) => error);
    },
    createModal() {
      // console.log('Create Engraving Modal', this.options);

      const $wrapper = document.createElement("div");
      $wrapper.classList += "engraving-modal hidden";
      $wrapper.setAttribute("role", "dialog");

      // Handlebars
      const rawTemplate = document.querySelector(
        "script[engraving-modal-template]"
      ).innerHTML;
      const template = Handlebars.compile(rawTemplate);

      $wrapper.innerHTML = template({
        ...this.options,
      });

      this.modal = $wrapper;
      document.body.appendChild($wrapper);
    },
    eventListeners() {
      const $modal = this.modal;
      const $innerModal = $modal.querySelector(".engraving-inner");
      const $closer = $modal.querySelector("#close-engraving");
      let $trigger = document.querySelector(".engraving-trigger");

      document.addEventListener("click", function (event) {
        if (event.target.classList.contains("engraving-trigger")) {
          $modal.classList.toggle("hidden");
        }
      });

      $modal.addEventListener("click", function (event) {
        // console.log('Modal Click', event.target);

        if (
          !$innerModal.contains(event.target) &&
          event.target !== $innerModal
        ) {
          $modal.classList.toggle("hidden");
        }

        if ($closer.contains(event.target) || $closer === event.target) {
          $modal.classList.toggle("hidden");
        }
      });

      const $addBtn = $modal.querySelector("button.engraving-submit");
      const $selects = $modal.querySelectorAll("select");
      const $inputs = $modal.querySelectorAll("input");
      const $mainAddBtn = document.querySelector(
        '.productForm button[type="submit"]'
      );

      $addBtn.addEventListener("click", this.saveEngravingHandler.bind(this));
      $mainAddBtn.addEventListener("click", this.submitHandler.bind(this));
      $selects.forEach(($select) => {
        $select.addEventListener(
          "change",
          this.propertyChangeHandler.bind(this)
        );
        $($select).trigger("change");
      });

      $inputs.forEach(($input) => {
        $input.addEventListener(
          "change",
          this.propertyChangeHandler.bind(this)
        );
        $($input).trigger("change");
      });
    },
    fetchProduct() {
      return fetch(`/products/engraving-personalization.js`)
        .then((res) => res.json())
        .catch(() => null);
    },
    modal: null,
    options: defaultEngravingOptions,
    propertyChangeHandler(event) {
      const name = event.target.name;
      const property = name.match(/\[(.*)\]/).pop();
      const value = event.target.value;
      const product = this.state.product;
      const $secondInput = document.querySelector(
        ".engraving-second-input-container"
      );

      const isStyle = /style/gi.test(event.target.name);
      const isGraphic = /graphic/gi.test(event.target.value);
      const isLocation = /location/gi.test(event.target.name);
      const isHandwritten = /handwritten/gi.test(event.target.value);

      if (isStyle) {
        const $label = document.querySelector(".engraving-value-wrapper label");
        const $input = document.querySelector("input#personalization");
        const $selectsContainer = document.querySelector(
          ".engraving-container.engraving-selects-wrapper"
        );

        // console.log('Style Change', { isGraphic, isHandwritten, $label, $input });
        if (isGraphic || isHandwritten) {
          $label.style.visibility = "hidden";
          $input.style.visibility = "hidden";
          $selectsContainer.classList.add("graphic");
          this.state.location = null;
          this.state.capitalization = null;
          this.state.personalization = null;

          // Reset Variant to $60
          const variant = product.variants.find(function (variant) {
            return variant.price == 60 * 100;
          });

          // console.log('Upgrade Variant', { variant }, product.variants, product);
          this.state.variant = variant;

          document.querySelector(".graphic-byline").innerHTML =
            engravingDisclaimers[value] ||
            "Send us a picture to engrave on your piece. We'll email you shortly after completing your order.";
        } else {
          $label.style.visibility = "visible";
          $input.style.visibility = "visible";
          $selectsContainer.classList.remove("graphic");
          this.state.personalization =
            document.querySelector("#personalization").value;
          document.querySelector(".graphic-byline").innerHTML =
            "Send us a picture to engrave on your piece. We'll email you shortly after completing your order.";

          // Reset Variant
          const options = this.options;
          const variant = product.variants.find(function (variant) {
            return variant.price == options.price * 100;
          });

          this.state.variant = variant;
        }
      }

      if (isLocation && $secondInput) {
        if (/&/gi.test(event.target.value)) {
          $secondInput.style.display = "block";
        } else {
          $secondInput.style.display = "none";
          $secondInput.value = "";
        }
      }

      this.state[property] = value;

      // console.log('Select Change Handler', this.state);
    },
    saveEngravingHandler() {
      const $trigger = document.querySelector(".engraving-trigger");
      const $textInput = document.querySelector("#personalization");
      const engravingStyle = this.state.style;
      this.state.saved = true;
      this.modal.classList.add("hidden");

      // console.log('save engraving', this.state, $textInput.value.length, $textInput.value);

      if (
        $textInput.value.length > 0 ||
        /(graphic|handwritten)/gi.test(engravingStyle)
      ) {
        $trigger.textContent = /graphic/gi.test(engravingStyle)
          ? "Graphic Engraving"
          : /handwritten/gi.test(engravingStyle)
          ? "Handwritten"
          : $textInput.value;
        $trigger.classList.add("active-engraving");
      } else {
        $trigger.textContent = "CLICK HERE TO ADD YOUR ENGRAVING";
        $trigger.classList.remove("active-engraving");
      }

      if (document.querySelector(".custom-select-wrapper")) {
        let $wrappers = document.querySelectorAll(".custom-select-wrapper");

        console.log("Update Type", $wrappers);

        [...$wrappers].forEach(($wrapper) => {
          let event = new CustomEvent("update:type", { detail: $wrapper });
          document.dispatchEvent(event);
        });
      }
    },
    async submitHandler(event) {
      const needsEngraving = this.state.saved;

      if (!needsEngraving) return;

      // Wait for original add first.
      await sleep(750);
      const add = await this.addEngraving();

      window.AjaxCart.getCart(window.AjaxCart.buildCart);
      // console.log('Submit Handler', add, this.state);
    },
    async start(options, mainProduct) {
      console.log("Start Engraving", options, this.options);

      const optionLocations = this.options.locations || [];
      const secondInput = optionLocations.some((item) => /&/gi.test(item));

      this.main_product = mainProduct;
      this.options = {
        ...this.options,
        ...options,
        secondInput,
      };

      this.createModal();
      this.eventListeners();

      const product = await this.fetchProduct();

      this.state.product = product;

      const variant = product.variants.find(function (variant) {
        return variant.price == options.price * 100;
      });

      // console.log('Engraving Variant', variant, options.price, options.price * 100, product.variants);

      this.state.variant = variant;
    },
    state: {
      capitalization: "",
      location: "",
      personalization: "",
      product: null,
      variant: null,
      saved: false,
      style: "",
    },
  };

  const PDP = {
    addonSubmission(justAdded) {
      // console.log('Check for Addon Submissions', justAdded);
      if (!justAdded) return;

      Addons.submitHandler(justAdded.key);
    },
    async checkCartState() {
      await sleep(1000);

      if (window.GWP) {
        window.GWP.start();
      }

      const cart = await this.fetchCart();
      const items = cart.items;

      // console.log('Check Cart State', items);

      const mainItemsForRemoval = items.filter(function (item) {
        const properties = item.properties;

        // console.log('Item Properties', properties, { item });

        if (!properties || properties["type"] === "addon") return false;

        if (properties.bundleID) {
          let matchingPair = [...items].find((otherItem) => {
            return (
              otherItem.properties &&
              otherItem.properties.bundleID === properties.bundleID &&
              otherItem.key !== item.key
            );
          });

          return !Boolean(matchingPair);
        }

        if (properties.Gemstone && properties.Gemstone !== "_none") {
          const gemstoneAddon = items.find(function (addonItem) {
            return (
              addonItem.properties && addonItem.properties["_main"] == item.key
            );
          });

          return !Boolean(gemstoneAddon);
        }

        if (properties["Necklace Chain"]) {
          const chainAddon = items.find(function (addonItem) {
            return (
              addonItem.properties && addonItem.properties["_main"] == item.key
            );
          });

          return !Boolean(chainAddon);
        }

        if (properties["Charm"]) {
          const charmAddon = items.find(function (addonItem) {
            return (
              addonItem.properties && addonItem.properties["_main"] == item.key
            );
          });

          return !Boolean(charmAddon);
        }

        if (properties["Gemstone"] && properties.Gemstone !== "_none") {
          const gemStoneAddon = items.find(function (addonItem) {
            return (
              addonItem.properties && addonItem.properties["_main"] == item.key
            );
          });

          // console.log('Gemstone 2 Remove', !Boolean(gemStoneAddon));
          return !Boolean(gemStoneAddon);
        }

        return false;
      });

      const addonItemsForRemoval = items.filter(function (item) {
        const properties = item.properties;

        if (/engraving/gi.test(item.handle)) {
          const main = items.find(
            (cartItem) => cartItem.product_title === item.properties.main
          );

          return !Boolean(main);
        }

        if (!item.properties) return false;

        if (!item.properties["type"] || item.properties["type"] !== "addon")
          return false;

        const mainKey = item.properties["_main"];
        const mainProduct = items.find((cartItem) => cartItem.key === mainKey);

        return !Boolean(mainProduct);
      });

      // console.log('Removal Items', addonItemsForRemoval, mainItemsForRemoval);

      const combinedRemovals = mainItemsForRemoval.concat(addonItemsForRemoval);

      if (combinedRemovals.length === 0) return;

      await Promise.all(
        [...combinedRemovals].map(async (item) => {
          const line = items.findIndex((cartItem) => cartItem.key == item.key);

          if (line === -1) return;
          // console.log('Remove Line', line+1, item);

          await this.removeItem(line + 1);

          return true;
        })
      );

      const newCart = await this.fetchCart();

      if (window.innerWidth < 768) {
        window.location.reload();
      }
      window.AjaxCart.buildCart(newCart);
      // console.log('Cart', {cart, newCart});
    },
    async removeItem(line) {
      const remove = {
        line: line,
        quantity: 0,
      };

      const options = {
        body: JSON.stringify(remove),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With":
            "xmlhttprequest" /* XMLHttpRequest is ok too, it's case insensitive */,
        },
        method: "POST",
      };

      const data = await fetch("/cart/change.js", options);

      // console.log('Item Removed', data);

      return data;
    },
    destroyInfiniteOptions() {
      const $options = document.querySelectorAll(".infinite-selector-wrapper");

      $options.forEach(function ($option) {
        // console.log('Destroying', $option);
        $option.parentElement.removeChild($option);
      });
    },
    mainKeyInput() {
      const $form = document.querySelector(
        'form[action="/cart/add"].productForm'
      );
      const $keyInput = $form.querySelector("#mainKey");

      if ($keyInput) return;

      const $newKeyInput = document.createElement("input");

      $newKeyInput.type = "hidden";
      $newKeyInput.value = createId();
      $newKeyInput.id = "mainKey";
      $newKeyInput.name = "properties[_key]";

      $form.prepend($newKeyInput);
    },
    engravingEngine(forceProduct = null) {
      const product = forceProduct || this.products[this.state.main];

      if (!product) return;
      const engravingTags = product.tags.find(function (tag) {
        return /^engraving/gi.test(tag);
      });

      if (!engravingTags) return false;

      // console.log('Engraving Tags', product.tags, engravingTags, engravingTags.split('|'));

      const engravingOptions = engravingTags
        .split("|")
        .reduce(function (options, option) {
          option = option.trim();

          if (option === "engraving") return options;

          let [key, value] = option.split(":");

          key = key.trim();
          value = value.trim();

          // console.log('Option', { key, value });

          if (key === "max" || key === "price") {
            options[key] = Number(value);
            return options;
          }

          if (key === "location") {
            options[key] = value.split("_");
            return options;
          }

          if (key === "include" && value === "graphic") {
            options["graphic"] = true;

            return options;
          }

          options[key] = value;

          return options;
        }, defaultEngravingOptions);

      this.mainKeyInput();
      Engraving.start(engravingOptions, product);
      return true;
    },
    fetchCart() {
      return fetch(`/cart.js`).then((res) => res.json());
    },
    fetchProduct(handle) {
      return fetch(`/products/${handle}.js`).then((res) => res.json());
    },
    ImageSliders() {
      $(".main-slider:not('.slick-initialized')").slick({
        arrows: false,
        accessibility: false,
        dots: false,
        fade: true,
        asNavFor: ".thumb-slider",
      });

      $(".thumb-slider:not('.slick-initialized')").slick({
        slidesToShow: 4,
        vertical: false,
        asNavFor: ".main-slider",
        focusOnSelect: true,
        accessibility: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              vertical: false,
            },
          },
        ],
      });

      function debounce(func) {
        var timer;
        return function (event) {
          if (timer) clearTimeout(timer);
          timer = setTimeout(func, 100, event);
        };
      }

      // This is handling a weird window-resize effect we were seeing
      // when you had any slick thumbnail select not in position 0.
      window.addEventListener(
        "resize",
        debounce(function (e) {
          var current = $(".thumb-slider").slick("slickCurrentSlide");
          $(".thumb-slider")[0].slick.refresh();

          setTimeout(function () {
            $(".thumb-slider").slick("slickGoTo", current);
          }, 500);
        })
      );

      $(".main-slider").on(
        "afterChange",
        function (event, slick, currentSlide) {
          const isVideoPlaying = (video) =>
            !!(
              video.currentTime > 0 &&
              !video.paused &&
              !video.ended &&
              video.readyState > 2
            );
          const $video = document.querySelector(
            `.main-slider .slick-slide[data-slick-index="${currentSlide}"] video`
          );

          if ($video) {
            // console.log('Video is not playing', $video);

            !isVideoPlaying($video) ? $video.play() : null;
          }

          // console.log('Main Slider Change', {$video, currentSlide});
        }
      );

      $(".thumb-slider").on(
        "afterChange",
        function (event, slick, currentSlide) {
          const currentMainIndex = $(".main-slider").slick("slickCurrentSlide");

          if (currentMainIndex !== currentSlide) {
            // console.log('Indexes dont match', { currentMainIndex, currentSlide });
            $(".main-slider").slick("slickGoTo", parseInt(currentSlide));
          }
          // console.log('Thumb slider Change', currentSlide);
        }
      );

      $(document).on("click", ".thumb-slider .slick-slide", function (event) {
        const index = $(".thumb-slider").slick("slickCurrentSlide");
        // const index = Number(event.currentTarget.getAttribute('data-slick-index'));

        // This is on a timeout because we do not always need to fire it. We want to give
        // the native slick engine a chance to do the right thing.
        setTimeout(function () {
          const currentMainIndex = $(".main-slider").slick("slickCurrentSlide");

          // console.log('Clicked', event.currentTarget, { index, currentMainIndex});
          if (index !== currentMainIndex) {
            // console.log('Go To', index);
            $(".main-slider").slick("slickGoTo", index);
          }
        }, 250);
      });

      if (document.querySelector(".related-feed")) {
        $(".related-feed").slick({
          slidesToShow: 4,
          slidesToScroll: 2,
          arrows: true,
          responsive: [
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              },
            },
          ],
        });
      }
    },
    ImageZoom() {
      // Zoom Pan Functionality.
      function handleMouseMove(e) {
        var zoomer = e.currentTarget;
        e.offsetX ? (offsetX = e.offsetX) : (offsetX = e.touches[0].pageX);
        e.offsetY ? (offsetY = e.offsetY) : (offsetX = e.touches[0].pageX);
        x = (offsetX / zoomer.offsetWidth) * 100;
        y = (offsetY / zoomer.offsetHeight) * 100;
        zoomer.style.backgroundPosition = x + "% " + y + "%";
      }

      const $allZooms = document.querySelectorAll(".main-slider figure");

      $allZooms.forEach(($zoom) => {
        $zoom.addEventListener("mousemove", handleMouseMove);
      });
    },
    ImageSwapHandler() {
      const $self = this;
      const productHandle = this.state.main;
      const product = this.products[productHandle];

      const newVariant = $self.state.variant
        ? [...product.variants].find(function (variant) {
            return ["option1", "option2", "option3"].every((key) => {
              return variant[key] === $self.state.variant[key];
            });
          })
        : [...product.variants][0];

      // if(newVariant) {
      //     self.state.variant = {
      //         ...newVariant,
      //     };
      // }

      function mainSlideHtml(image, index, arr) {
        return `
                <div class="main-slide">
                    <figure class="zoom" style="background-image: url(${getSizedImageUrl(
                      image.src,
                      "2048x"
                    )})">
                        <img src="${getSizedImageUrl(
                          image.src,
                          "2048x"
                        )}" alt="${image.alt}" />
                    </figure>
                </div>
                `;
      }

      function thumbSlideHtml(image, index, arr) {
        return `
                <div class="thumb-slide" ${
                  image.variants.length
                    ? `data-variant="${image.variants
                        .map((v) => v.id)
                        .join(",")}"`
                    : ""
                }>
                    <img src="${getSizedImageUrl(
                      image.src,
                      "750x"
                    )}" alt="Thumbnail ${index + 1} of ${arr.length}" />
                </div>
                `;
      }

      // Shape Media & Metafield Images.
      const mediaImages = [...product.media].reduce(function (images, media) {
        if (media.media_type !== "image") return images;

        const image = {
          src: media.src,
          alt: media.alt,
          variants: [...product.variants].filter(function (variant) {
            return variant.featured_media
              ? variant.featured_media.preview_image.src === media.src
              : false;
          }),
        };

        images.push(image);

        return images;
      }, []);

      const metaImages = [...product.metafields.images].reduce(function (
        images,
        metafield
      ) {
        if (!metafield || metafield.length === 0) return images;

        const image = {
          src: metafield,
          alt: "",
          variants: [],
        };

        images.push(image);

        return images;
      },
      []);

      const mainSlides = [...mediaImages, ...metaImages].map(mainSlideHtml);
      const thumbnailSlides = [...mediaImages, ...metaImages].map(
        thumbSlideHtml
      );

      $(".thumb-slider").slick("unslick");
      $(".main-slider").slick("unslick");

      document.querySelector(".main-products-image").innerHTML = `
              <div class="thumb-slider">
               ${thumbnailSlides.join("")}
              </div>
              <div class="main-slider">
               ${mainSlides.join("")}
              </div>
            `;

      function startSliders() {
        $(".main-slider:not('.slick-initialized')").slick({
          arrows: false,
          accessibility: false,
          dots: false,
          fade: true,
          asNavFor: ".thumb-slider",
        });

        $(".thumb-slider:not('.slick-initialized')").slick({
          slidesToShow: 4,
          vertical: true,
          asNavFor: ".main-slider",
          focusOnSelect: true,
          accessibility: false,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                vertical: false,
              },
            },
          ],
        });
      }

      const $images = document.querySelectorAll(
        ".main-products-image .thumb-slider img"
      );

      const imgCount = $images.length;
      let loadCount = 0;

      $images.forEach(function ($img) {
        $img.addEventListener("load", function (event) {
          loadCount++;

          if (loadCount == imgCount) {
            startSliders();
          }
        });
      });

      if (newVariant) {
        // Update Variant Selectors
        let $inputs = ["option1", "option2", "option3"].map((key) => {
          return document.querySelector(
            `.variant-options-table .single-option-selector[data-option="${key}"]`
          );
        });

        setTimeout(function () {
          ["option1", "option2", "option3"].forEach((key) => {
            let $input = document.querySelector(
              `.variant-options-table .single-option-selector[data-option="${key}"]`
            );

            // console.log('Input Option?', { $input, key });
            if ($input) {
              // $input.value = newVariant[key];
              $($input).trigger("change");
              // console.log('change on input', $input);
            }
          });
        }, 500);
      }
    },
    infiniteOptions() {
      const self = this;
      // Create "window.Shoppad.apps.infiniteoptions" object if it doesn't already exist
      "Shoppad.apps.infiniteoptions".split(".").reduce(function (o, x) {
        if (!o[x]) {
          o[x] = {};
        }
        return o[x];
      }, window);

      window.Shoppad.apps.infiniteoptions.beforeReady = function (subscribe) {
        subscribe("appLoad", function (event) {
          // console.log('Infinite Options appLoad', event);
          const detail = event.detail;
          const fields = detail.fields;

          if (fields.length > 1) {
            //   document.querySelector('#infiniteoptions-container').style.gridColumn = 'span 2';
          }
        });

        subscribe("fieldLoad", self.infiniteOptionsHandlers.fieldLoad);
        subscribe("fieldChange", self.infiniteOptionsHandlers.fieldChange);
      };
    },
    infiniteOptionsHandlers: {
      fieldLoad(event) {
        /**
         * @param {object} event
         * @param {string} event.detail.name The field name of the input.
         * @param {string} event.detail.value The value of the input.
         * @param {object} event.detail.element A jQuery object representing the element that added to the DOM (this is the parent <div> that wraps the input and label).
         * @param {object} event.detail.fieldConfig
         * @param {boolean} event.detail.hasConditionalLogic True if the field utilizes conditional logic.
         * @param {boolean} event.detail.hasBundledProducts True if the field has product bundles attached in it's initial state.
         */
        //               // console.log('Nested Infinite Options Field Load', event);
      },

      fieldChange(event) {
        /**
         * @param {object} event
         * @param {string} event.detail.name The field name of the input.
         * @param {string} event.detail.value The value of the input.
         * @param {object} event.detail.element A jQuery object representing the element that added to the DOM (this is the parent <div> that wraps the input and label).
         */
        //      // console.log('Field Change', event.detail);
      },
    },
    updateMadeToOrderProperty(variant) {
      const isEngraving =
        document.querySelector(".engraving-trigger") &&
        document
          .querySelector(".engraving-trigger")
          .classList.contains("active-engraving");
      const $prop = document.querySelector("#orderTypeProp");
      const $mtoDisclaimer = document.getElementById("mto-disclaimer");
      const $rteDisclaimer = document.getElementById("rts-disclaimer");

      //   console.log('Update MTO Property Disclaimer', {isEngraving, variant,  management: !variant.inventory_management, combo: (variant.inventory_quantity < 1 && variant.inventory_policy == 'continue') }, !document.body.classList.contains('pdp-ready'));

      if (!document.body.classList.contains("pdp-ready")) return;

      // console.log('Update MTO Prop:', variant);

      if (!variant) {
        if ($rteDisclaimer) $rteDisclaimer.style.display = "none";
        if ($mtoDisclaimer) $mtoDisclaimer.style.display = "none";

        if ($prop) $prop.setAttribute("name", "");

        return;
      }

      if (
        !variant.inventory_management ||
        isEngraving ||
        (variant.inventory_quantity < 1 &&
          variant.inventory_policy == "continue")
      ) {
        if ($prop) $prop.setAttribute("name", "properties[Order Type]");
        if ($mtoDisclaimer) $mtoDisclaimer.style.display = "block";
        if ($rteDisclaimer) $rteDisclaimer.style.display = "none";
        return "Made To Order";
      } else {
        if ($mtoDisclaimer) $mtoDisclaimer.style.display = "none";
        if ($rteDisclaimer) $rteDisclaimer.style.display = "block";
        if ($prop) $prop.setAttribute("name", "");
      }
    },
    optionCallback(option, variants) {
      const isEngraving =
        document.querySelector(".engraving-trigger") &&
        document
          .querySelector(".engraving-trigger")
          .classList.contains("active-engraving");
      const mainHandle = this.state.main;
      const product = this.products[mainHandle];

      let { value, index } = option;

      if (/gift-card/gi.test(product.handle)) return "";

      if (!variants) variants = product.variants;

      const inStockVariant = [...variants].find(
        (variant) =>
          variant[`option${index}`] === value &&
          variant.inventory_quantity > 0 &&
          variant.inventory_management
      );
      const variant = [...variants].find(
        (variant) => variant[`option${index}`] === value
      );

      if (
        inStockVariant ||
        (variant &&
          variant.inventory_quantity > 0 &&
          variant.inventory_management)
      )
        return "In Stock";

      if (!variant || !variant.inventory_management || isEngraving)
        return "Made To Order";

      if (
        variant.inventory_policy == "continue" &&
        variant.inventory_quantity < 1
      )
        return "Made To Order";

      if (variant.inventory_policy === "deny" && variant.inventory_quantity < 1)
        return "Out Of Stock";

      return "Out Of Stock";
    },
    setupOptionSelects() {
      const $self = this;
      const mainHandle = this.state.main;
      const companionHandle = this.state.companion;
      const product = this.products[mainHandle];
      const companion = this.products[companionHandle];

      function filterSettings(data) {
        const equals = data.equals;
        const type = data.type;
        const values = data.values;

        if (type == "tag") {
          const tagTest = new RegExp("^" + equals + "($|\\d$| count)", "i");
          const productTag = product.tags.find((tag) => {
            return tagTest.test(tag);
          });

          return Boolean(productTag);
        }

        return false;
      }

      const $data = document.querySelector("script[data-infinite-options]");
      const data = JSON.parse($data.innerHTML);
      const optionsThatQualify = data.filter(filterSettings);
      const infiniteOptionsByName = [...optionsThatQualify].reduce(
        (options, infiniteOption) => {
          let { label, values } = infiniteOption;

          options[label.toLowerCase()] = values;

          return options;
        },
        {}
      );

      const options = [...product.options].map((name, index) => {
        let values = [...product.variants].reduce((values, variant) => {
          let v = [...new Set(values.concat(variant[`option${index + 1}`]))];
          v = v.filter((v) => !/made to order/i.test(v));

          return v;
        }, []);

        if (infiniteOptionsByName[name.toLowerCase()]) {
          values = [
            ...new Set(
              values.concat(infiniteOptionsByName[name.toLowerCase()])
            ),
          ].sort((a, b) =>
            a.localeCompare(b, undefined, {
              numeric: true,
            })
          );
        }

        if (/size/gi.test(name.toLowerCase())) {
          values = [...values].sort((a, b) => Number(a) - Number(b));
        }

        return {
          name,
          index,
          values,
        };
      });

      console.log("Product Options", { options });

      function createOptionDropdowns(option, index) {
        let $wrapper = document.createElement("div");

        $wrapper.classList.add("select-option__wrapper");

        if (index === options.length - 1) {
          $wrapper.classList.add("final-option");
        }

        console.log(
          "Creating Option",
          [...option.values].sort((a, b) =>
            a.localeCompare(b, "en", { numeric: true })
          )
        );

        let html = `
                  <span class="selectArrow"></span>
                  <label>${option.name}</label>
                  <div class="custom-select-wrapper" data-option="${
                    option.name
                  }">
                    <select class="select-option selectNative js-selectNative" name="${
                      option.name
                    }" data-option="${option.index}">
                        <option value="">Select ${option.name}</option>
                        ${[...option.values]
                          .map((value) => {
                            const $option = document.createElement("option");
                            const $container = document.createElement("div");

                            $option.textContent = value;
                            $option.setAttribute("value", value);

                            $container.appendChild($option);

                            return $container.innerHTML;
                          })
                          .join("")}
                    </select>
                    <custom-select ${
                      option.name.toLowerCase() === "size"
                        ? ""
                        : 'data-auto-select="true"'
                    } class="selectCustom js-selectCustom option-${option.name.toLowerCase()}" data-option="${
          option.index
        }" aria-hidden="true">
                        <div class="selectCustom-trigger">Select ${
                          option.name
                        }</div>

                        <div class="selectCustom-options">
                        ${[...option.values]
                          .map((value) => {
                            const $wrapper = document.createElement("div");

                            $wrapper.setAttribute("data-value", value);
                            $wrapper.setAttribute(
                              "data-type",
                              $self.optionCallback({
                                value,
                                index: option.index + 1,
                              })
                            );
                            $wrapper.textContent = value;

                            $wrapper.classList.add("dropdown-option");

                            const $container = document.createElement("div");
                            $container.appendChild($wrapper);

                            return $container.innerHTML;
                          })
                          .join("")}
                        </div>
                    </custom-select>
                  </div>
                `;

        $wrapper.innerHTML = html;

        if (/(default|title)/gi.test(option.name)) {
          $wrapper.style.display = "none";
        }

        document.addEventListener("update:type", function (event) {
          let optionNameMatch = option.name === event.detail.dataset.option;
          if (!optionNameMatch) return;

          const $options = event.detail.querySelectorAll(".dropdown-option");

          [...$options].forEach(($opt) => {
            let value = $opt.getAttribute("data-value");

            $opt.setAttribute(
              "data-type",
              $self.optionCallback({ value, index: option.index + 1 })
            );
          });
        });

        return $wrapper;
      }

      const $options = [...options].map(createOptionDropdowns);

      const $infiniteOptionsContainer = document.querySelector(
        ".productForm-block #infiniteoptions-container"
      );

      console.log("Create Option Selects", {
        $options,
        $infiniteOptionsContainer,
      });

      [...$options].forEach(($option) => {
        document
          .querySelector(".variant-options-table .productForm-block")
          .insertBefore($option, $infiniteOptionsContainer);
        // document.querySelector('.variant-options-table .productForm-block').appendChild($option)
      });

      console.log("Setup Option Selects", { product, companion, options });
    },
    pageModal(page) {
      if (document.querySelector(".page-modal"))
        document
          .querySelector(".page-modal")
          .parentElement.removeChild(document.querySelector(".page-modal"));

      const $modal = document.createElement("div");

      $modal.classList.add("page-modal");

      let html = `
             <div class="page-modal__wrapper bg-accent" id="page-${page.handle}">
               <button type="button" class="page-modal__close"><div></div></button>
               <div class="rte">${page.content}</div>
             </div>
            `;

      $modal.innerHTML = html;

      document.body.appendChild($modal);

      $modal
        .querySelector(".page-modal__close")
        .addEventListener("click", () => {
          $modal.parentElement.removeChild($modal);
        });
    },
    setUpPageModals() {
      const pageCache = {};
      const $self = this;
      const $btns = document.querySelectorAll(".product-metafield__modal-cta");
      const $sizeGuide = document.querySelector("#size-guide__trigger");

      function fetchPage(handle) {
        if (pageCache[handle]) return pageCache[handle];

        return fetch(`/pages/${handle}?view=json`)
          .then((res) => res.json())
          .then((page) => {
            pageCache[handle] = page;
            return page;
          });
      }

      async function clickHandler(event) {
        event.preventDefault();

        const pageHandle = event.currentTarget.dataset.page;
        const page = await fetchPage(pageHandle);

        $self.pageModal(page);
      }

      [...$btns].forEach(($btn) =>
        $btn.addEventListener("click", clickHandler)
      );

      if ($sizeGuide) {
        $sizeGuide.addEventListener("click", clickHandler);
      }
    },
    async searchSimilarProducts() {
      const mainHandle = this.state.main;
      const product = this.products[mainHandle];

      const linkedLabel = [...product.tags].reduce((label, tag) => {
        return /linked-products/i.test(tag) ? tag.split(":")[1] : label;
      }, null);

      if (!linkedLabel) return;

      function sendSearch(query) {
        console.log("Similar URL?", `/search?q=${query}&type=product`);

        return fetch(`/search?q=${query}&type=product&view=json`).then((res) =>
          res.json()
        );
      }

      function editDistance(s1, s2) {
        s1 = s1.toLowerCase();
        s2 = s2.toLowerCase();

        var costs = new Array();
        for (var i = 0; i <= s1.length; i++) {
          var lastValue = i;
          for (var j = 0; j <= s2.length; j++) {
            if (i == 0) costs[j] = j;
            else {
              if (j > 0) {
                var newValue = costs[j - 1];
                if (s1.charAt(i - 1) != s2.charAt(j - 1))
                  newValue =
                    Math.min(Math.min(newValue, lastValue), costs[j]) + 1;
                costs[j - 1] = lastValue;
                lastValue = newValue;
              }
            }
          }
          if (i > 0) costs[s2.length] = lastValue;
        }
        return costs[s2.length];
      }

      function similarity(s1, s2) {
        var longer = s1;
        var shorter = s2;
        if (s1.length < s2.length) {
          longer = s2;
          shorter = s1;
        }
        var longerLength = longer.length;
        if (longerLength == 0) {
          return 1.0;
        }
        return (
          (longerLength - editDistance(longer, shorter)) /
          parseFloat(longerLength)
        );
      }

      let titleWords = product.title.split(" ");
      titleWords.shift();

      titleWords = titleWords.join(" ").replace(/ *\([^)]*\) */g, "");

      const search = await sendSearch(titleWords);

      function removeUniqIdentifier(str) {
        return str.replace(/ *\([^)]*\) */g, "");
      }

      console.log("Search Results", search.results, titleWords);

      const resultsWithRating = [...search.results].reduce(
        (results, result) => {
          let rating = similarity(
            removeUniqIdentifier(result.title),
            removeUniqIdentifier(product.title)
          );

          console.log("Rating Compare", rating, result.title);

          if (rating < 0.98 || /ready-to-ship/gi.test(result.title))
            return results;

          results.push(result);

          return results;
        },
        []
      );

      if (!resultsWithRating.length) return;

      const linkedItems = [...resultsWithRating].map((item) => {
        let title = item.title.split(" ");
        let otherProductWords = [...resultsWithRating].reduce(
          (other, item2) => {
            if (item2.title === item.title) return other;

            other = other.concat(item2.title.split(" "));

            return other;
          },
          []
        );

        let isolatedWords = [...title].filter(
          (word) => !otherProductWords.includes(word)
        );

        let matches = /\(([^)]+)\)/.exec(item.title);
        let special_title = matches && matches[1] ? matches[1] : isolatedWords;

        console.log("Matches", { title: item.title, special_title });

        return {
          ...item,
          isolatedWords,
          special_title,
        };
      });

      let $wrapper = document.createElement("div");

      $wrapper.classList.add("select-option__wrapper");

      let pageProduct = { ...product };
      let html = `
                <span class="selectArrow"></span>
                <label>${linkedLabel}</label> 
                <div class="custom-select-wrapper" data-option="${linkedLabel}">
                    <select class="select-option selectNative js-selectNative" name="linkedLabel" >
                        <option value="">Select ${linkedLabel}</option>
                        ${[...linkedItems]
                          .map(
                            (product) =>
                              `<option value="${product.handle}">${product.special_title}</option>`
                          )
                          .join("")}
                    </select>
                    <custom-select class="selectCustom js-selectCustom option-${linkedLabel}" data-linked-products aria-hidden="true">
                        <div class="selectCustom-trigger">Select ${linkedLabel}</div>

                        <div class="selectCustom-options">
                        ${[...linkedItems]
                          .map(
                            (product) =>
                              `<div class="dropdown-option" data-value="${
                                product.handle
                              }" ${
                                product.handle === pageProduct.handle
                                  ? "default-item"
                                  : ""
                              }>${product.special_title}</div>`
                          )
                          .join("")}
                        </div>
                    </custom-select>
                </div>  
            `;

      $wrapper.innerHTML = html;

      const $formOptions = document.querySelector(
        ".productForm-block.productForm-block--options-inline"
      );
      const $infiniteOptions = $formOptions.querySelector(
        "#infiniteoptions-container"
      );

      $formOptions.insertBefore($wrapper, $infiniteOptions);

      $wrapper.querySelector("select").addEventListener("change", (event) => {
        let handle = event.target.value;

        if (handle === pageProduct.handle) return;

        window.location = `/products/${handle}`;
      });
    },
    singlePairDropdown() {
      const mainHandle = this.state.main;
      const product = this.products[mainHandle];
      console.log("Single Pair Dropdown", product);

      let $wrapper = document.createElement("div");

      $wrapper.classList.add("select-option__wrapper");

      let html = `
                <span class="selectArrow"></span>
                <label>SINGLE OR PAIR</label>
                <div class="custom-select-wrapper" data-option="SINGLE OR PAIR">
                    <select class="select-option selectNative js-selectNative" name="single-pair" >
                        <option value="">Select SINGLE OR PAIR</option>
                        <option value="1">Single</option>
                        <option value="2">Pair</option>
                    </select>
                    <custom-select class="selectCustom js-selectCustom option-single-pair" data-linked-products aria-hidden="true">
                        <div class="selectCustom-trigger">SINGLE OR PAIR</div>

                        <div class="selectCustom-options">
                          <div class="dropdown-option" data-value="1">Single</div>
                          <div class="dropdown-option" data-value="2">Pair</div>
                        </div>
                    </custom-select>
                </div>  
            `;

      $wrapper.innerHTML = html;

      const $formOptions = document.querySelector(
        ".productForm-block.productForm-block--options-inline"
      );
      const $infiniteOptions = $formOptions.querySelector(
        "#infiniteoptions-container"
      );

      $formOptions.insertBefore($wrapper, $infiniteOptions);

      console.log(
        "Event Listener",
        document.querySelector('select[name="single-pair"]')
      );

      document.addEventListener("change", (event) => {
        // singlePairProp
        const $inputProp = document.querySelector("#singlePairProp");

        if (event.target.matches('select[name="single-pair"]')) {
          let newQuantity = event.target.value;

          console.log("Pair Quantity", { newQuantity });

          if (newQuantity === "2") {
            $inputProp.name = `properties[Earring]`;
            $inputProp.value = "Pair";
          } else {
            $inputProp.name = "";
            $inputProp.value = "";
          }
          const changeEvent = new Event("change");
          document.querySelector("#quantity").value = newQuantity;
          document.querySelector("#quantity").dispatchEvent(changeEvent);
        }
      });

      // Hide Quantity
      document.querySelector("#qty-wrapper").style.display = "none";
    },
    quantityHandler() {
      const $self = this;
      const mainHandle = this.state.main;
      const product = this.products[mainHandle];
      let $quantity = document.querySelector("#quantity");

      $quantity.addEventListener("change", function (event) {
        let quantity = event.target.value;
        let $id = document.querySelector('[name="id"]');
        let currentVariantId = $id.value;
        let variant = [...product.variants].find(
          (variant) => variant.id == currentVariantId
        );

        let price = window.Shopify.formatMoney(
          variant.price * quantity,
          "${{amount_no_decimals}}"
        );

        let $price = document.querySelector(".product-normal-price");

        $price.textContent = price;
      });
    },
    init() {
      const $self = this;
      this.productsJSON();
      const mainHandle = this.state.main;
      const product = this.products[mainHandle];

      // console.log('Init Product', this.state, this.products, product);
      if (!product) return;

      this.setupOptionSelects();
      this.quantityHandler();
      this.setUpPageModals();
      this.searchSimilarProducts();

      // this.infiniteOptions();
      this.mtoHandlers();
      this.engravingEngine();
      this.tabs();

      this.initializeAddons();
      this.loadInfiniteOptions();
      this.pdfHandler();

      document.querySelector(".productForm-block").classList.add("ready");

      if (product.tags.includes("single-and-pair-dropdown")) {
        this.singlePairDropdown();
      }

      $(document).on("ready", function () {
        $self.ProductImages();
        const currentSlide = $(".thumb-slider").slick("slickCurrentSlide");
        const settings = $(".thumb-slider").slick("getSlick");

        const currentLeft = settings.currentLeft;
        const slideCount = settings.slideCount;

        // console.log('PDP DOC READY', { currentSlide, settings, currentLeft, slideCount }, currentSlide < slideCount && (currentLeft && currentLeft !== 0));

        if (currentSlide < slideCount && currentLeft && currentLeft !== 0) {
          // console.log('======= SLIDER NOT POSITIONED CORRECTLY =======', { currentSlide, slideCount, currentLeft });
          $(".thumb-slider").slick("slickGoTo", 0);
          $(".thumb-slider").slick("setPosition");
          $(".thumb-slider").slick("slickGoTo", currentSlide);

          setTimeout(function () {
            $(".main-slider").slick("slickGoTo", currentSlide);
          }, 500);
        }

        $(".thumb-slider").addClass("showing");

        document
          .querySelector(".row.main-product-row")
          .classList.add("pdp-ready");
      });

      $(window).on("load", function () {
        // console.log('PDP WINDOW LOAD');
      });
    },
    pdfHandler() {
      const $btn = document.querySelector("#generate-card");
      const $self = this;

      async function fetchPdf(body) {
        // go to PDF generation endpoint
        window.location = `https://ctwf-pdf.herokuapp.com/pdf?title=${body.title}&img=${body.image}`;
      }

      async function clickHandler(event) {
        event.preventDefault();
        let product = $self.products[$self.state.main];

        let card = await fetchPdf({
          title: product.title.toUpperCase(),
          image: product.images[0],
        });

        // console.log('Click PDF', { product, $self, card });
      }

      $btn.addEventListener("click", clickHandler);
    },
    async initializeAddons(optionalProduct = null) {
      const mainHandle = this.state.main;
      const product = optionalProduct || this.products[mainHandle];
      const addonData = JSON.parse(
        document.querySelector("script[data-pdp-addons]").innerHTML
      );

      const qualifyingAddons = addonData.filter((addon) => {
        if (addon.type !== "Addon") return false;

        const addonTest = new RegExp("^" + addon.tag, "i");

        const qualifyingTag = product.tags.find((tag) => addonTest.test(tag));
        return Boolean(qualifyingTag);
      });

      // console.log('Qualifying?', qualifyingAddons, addonData);

      let addonProducts = await Promise.all(
        [...qualifyingAddons].map(async (addon) => {
          const isCollection = addon.collection.length > 0;
          const tag = product.tags.find((tag) => tag.includes(addon.tag));

          addon.tag = tag;

          if (isCollection) {
            const products = await Promise.all(
              [...addon.collection].map(async (handle) => {
                const product = await this.fetchProduct(handle);

                return product;
              })
            );

            addon.collection = [...products];
          } else {
            const product = await this.fetchProduct(addon.addon);
            addon.product = product;
            addon.collection = null;
          }

          return addon;
        })
      );

      const qualifyingUnions = [...addonData]
        .filter((addon) => {
          if (addon.type === "Addon") return false;

          const addonTags = addonProducts.map((item) => item.tag);

          const triggers = addon.union_tags.split(",");

          return triggers.every((tag) => {
            return addonTags.includes(tag);
          });
        })
        .map((addon) => {
          const union_tags = addon.union_tags.split(",");
          const addons = [...addonProducts].filter((item) => {
            return union_tags.includes(item.tag);
          });

          return {
            ...addon,
            union_tags,
            addons,
          };
        });

      // console.log('What is going on', { qualifyingUnions });

      addonProducts = [...addonProducts].map((addon) => {
        const union = [...qualifyingUnions].find((item) => {
          return item.union_tags.includes(addon.tag);
        });

        return {
          ...addon,
          union,
        };
      });

      // console.log('Qualifyting Addon', {qualifyingAddons, addonProducts, optionalProduct});

      if (!optionalProduct) {
        // console.log('Before', this.state.addons, addonProducts);

        this.state.addons = this.state.addons || [];
        this.state.addons = [...this.state.addons, addonProducts];
        this.mainKeyInput();
        Addons.start(addonProducts);

        if (qualifyingUnions.length > 0) {
          Addons.unionStart(qualifyingUnions);
        }
      } else {
        // console.log('Returning Addons', { addonProducts }, this.state.addons);
        return addonProducts;
      }
    },
    loadInfiniteOptions(optionalProduct = null) {
      const $data = document.querySelector("script[data-infinite-options]");

      console.log("Load Infinite Options");

      if (!$data) return;

      const $self = this;
      const mainHandle = this.state.main;
      const product = optionalProduct || this.products[mainHandle];

      if (!product) return;

      function filterSettings(data) {
        const equals = data.equals;
        const type = data.type;

        const productOption = [...product.options].find((opt) => {
          let test = new RegExp(opt, "i");

          return test.test(data.label);
        });

        if (productOption) return false;

        if (type == "tag") {
          const tagTest = new RegExp("^" + equals + "($|\\d$| count)", "i");
          const productTag = product.tags.find((tag) => {
            return tagTest.test(tag);
          });

          return Boolean(productTag);
        }

        return false;
      }

      function optionsToHtml(option, index, count) {
        /*
                let customSelectHtml = `                
                <div class="custom-select-wrapper" data-option="${option.name}">
                    <select class="select-option selectNative js-selectNative" name="${option.name}" data-option="${option.index}">
                        <option value="">Select ${option.name}</option>
                        ${
                            [...option.values].map((value) => `<option value="${value}">${value}</option>`).join('')
                        }
                    </select>
                    <custom-select class="selectCustom js-selectCustom option-${option.name.toLowerCase()}" aria-hidden="true">
                        <div class="selectCustom-trigger">Select ${option.name}</div>

                        <div class="selectCustom-options">
                        ${
                            [...option.values].map((value) => `<div class="dropdown-option" data-value="${value}" data-type="${$self.optionCallback({ value, index: option.index+1 })}">${value}</div>`).join('')
                        }
                        </div>
                    </custom-select>
                </div>he
                `
                */

        // console.log('Infinite Option', option, count);

        if (option.as_input) {
          const tagExp = new RegExp(option.equals, "ig");
          const maxValue = option.productTag.replace(tagExp, "").trim();
          const max = Number(maxValue) || null;

          // console.log('Input Max', max);

          return `
                    <div class="infinite-selector-wrapper input-wrapper" data-id="infinite-select-option-${index}">
                      <label for="infinite-select-option-${index}">${
            option.label
          }</label>
                      <input id="infinite-select-option-${index}" class="infiniteoption-input" type="text" ${
            max ? `maxlength="${max}"` : ""
          } name="properties[${option.label}]" />
                    </div>
                    `;
        }

        if (count) {
          const lengthMap = arrayOfLength(count);
          let html = lengthMap
            .map((n) => {
              return `
                        <div class="infinite-selector-wrapper" data-count data-id="infinite-select-option-${index}">
                          <span class="selectArrow"></span>
                          <label for="infinite-select-option-${index}">${
                option.label
              } ${n}</label>
                          <select id="infinite-select-option-${index}" name="properties[${
                option.label
              } ${n}]" data-option="infinite${index}" class="single-option-selector">
                            ${option.values
                              .map(function (value) {
                                return `
                                 <option value="${value}">${value}</option>
                                `;
                              })
                              .join("")}
                          </select>
                        </div>
                       `;
            })
            .reduce((final, each) => final.concat(each), []);

          return option.label.toLowerCase() === "birthstone"
            ? `<div class="birthstones-container"><p>Birthstones</p><div class="birthstones-wrapper">${html.join(
                ""
              )}</div></div>`
            : html;
        }

        return `          
                <div class="select-option__wrapper">
                    <span class="selectArrow"></span>
                    <label>${option.label}</label>
                    <div class="custom-select-wrapper" data-option="${
                      option.label
                    }" data-id="infinite-select-option-${index}">
                        <select class="select-option selectNative js-selectNative" name="properties[${
                          option.label
                        }]" data-option="infinite${index}" >
                            <option value="">Select ${option.label}</option>
                            ${[...option.values]
                              .map(
                                (value) =>
                                  `<option value="${value}">${value}</option>`
                              )
                              .join("")}
                        </select>
                        <custom-select class="selectCustom js-selectCustom option-${option.label.toLowerCase()}" data-option="infinite${index}" aria-hidden="true">
                            <div class="selectCustom-trigger">Select ${
                              option.label
                            }</div>

                            <div class="selectCustom-options">
                            ${[...option.values]
                              .map(
                                (value) =>
                                  `<div class="dropdown-option" data-value="${value}" data-type="${$self.optionCallback(
                                    { value, index: option.index + 1 }
                                  )}">${value}</div>`
                              )
                              .join("")}
                            </div>
                        </custom-select>
                    </div>      
                </div>          
                `;
      }

      const data = JSON.parse($data.innerHTML);

      const optionsThatQualify = data.filter(filterSettings);

      console.log("Qualified Infinite Options:", optionsThatQualify);
      // No infinite options to build.
      if (optionsThatQualify.length === 0) return;

      const optionHTML = optionsThatQualify.map((option, index) => {
        const tagTest = new RegExp("^" + option.equals, "i");
        const productTag = product.tags.find((tag) => {
          return tagTest.test(tag);
        });
        const count = productTag.match(/count:\d+/)
          ? Number(productTag.match(/count:\d+/)[0].split(":")[1])
          : null;

        option.productTag = productTag;

        return optionsToHtml(option, index, count, optionsThatQualify.length);
      });

      console.log("Addons Optional Product:", optionalProduct);

      if (!optionalProduct) {
        document
          .querySelector(".productForm-block.productForm-block--options-inline")
          .setAttribute("data-options", optionsThatQualify.length + 1);

        const $formOptions = document.querySelector(
          ".productForm-block.productForm-block--options-inline"
        );
        const $infiniteOptions = $formOptions.querySelector(
          "#infiniteoptions-container"
        );

        // Instead of updating all html, we will insert before the infinite options.
        optionHTML
          .reduce((final, each) => final.concat(each), [])
          .forEach((html) => {
            const $hWrapper = document.createElement("div");
            $hWrapper.innerHTML = html;
            // console.log('H Wrapper', $hWrapper, $hWrapper.children[0]);
            // $formOptions.appendChild($hWrapper.children[0]);

            $formOptions.insertBefore($hWrapper.children[0], $infiniteOptions);
          });

        if ($formOptions.querySelector(".birthstones-wrapper")) {
          setTimeout(() => {
            $(".birthstones-wrapper").slick({
              slidesToShow: 1,
            });
          }, 1000);
        }

        // $formOptions.innerHTML += optionHTML;
      } else {
        return {
          optionHTML: optionHTML.join(""),
          optionsThatQualify,
        };
      }
    },
    async checkAndBuildMTo() {
      const product = this.products[this.state.main];
      // console.log('Check and Build?', product);

      const query = product.title
        .replace(/\((Ready To Ship|Ready-To-Ship)\)/gi, "")
        .trim();
      const searchResults = await fetch(
        `/search?q=${query}&type=product&view=json`
      ).then((res) => res.json());

      const cleanTitle = product.title
        .replace(/\((Ready To Ship|Ready-To-Ship)\)/gi, "")
        .replace(/\+/gi, "\\+")
        .trim();
      const titleText = new RegExp("^" + cleanTitle, "i");

      // console.log('Search Reults', searchResults.results);

      const matchingItem = searchResults.results
        .map((item) => {
          return {
            ...item.product,
            metafields: item.metafields,
          };
        })
        .find((item) => {
          return titleText.test(item.title) && product.handle !== item.handle;
        });

      if (!matchingItem) return false;

      const items = [product, matchingItem];

      // console.log('Items', items);

      const products = {
        readyToShip: items.find((item) =>
          /\((Ready To Ship|Ready-To-Ship)\)/gi.test(item.title)
        ),
        madeToOrder: items.find(
          (item) => !/\((Ready To Ship|Ready-To-Ship)\)/gi.test(item.title)
        ),
      };

      this.products[matchingItem.handle] = matchingItem;

      // console.log('Matching Title', cleanTitle, matchingItem, products);

      if (!products.madeToOrder || !products.readyToShip) return;

      const swatchHTML = `
                <div class="mto-swatches-wrapper">
                    <fieldset class="swatch-fieldset">
                    <legend>Select Product Type</legend>
                    <div class="swatch-box">
                        <input type="radio" name="product-type" data-handle="${
                          products.madeToOrder.handle
                        }" id="made-to-order-type" value="Made To Order" ${
        product.handle === products.madeToOrder.handle ? "checked" : ""
      } />
                        <label for="made-to-order-type">MADE TO ORDER</label>
                    </div>
                    <div class="swatch-box">
                        <input type="radio" name="product-type" data-handle="${
                          products.readyToShip.handle
                        }" id="ready-to-ship-type" value="Ready To Ship" ${
        product.handle === products.readyToShip.handle ? "checked" : ""
      } />
                        <label for="ready-to-ship-type">READY TO SHIP</label>
                    </div>
                    </fieldset>
                </div>
            `;

      document.querySelector(".mto-swatches-container").innerHTML = swatchHTML;

      return true;
    },
    async mtoHandlers() {
      let $inputs = document.querySelectorAll('input[name="product-type"]');
      const self = this;
      let allSwatches = document.querySelectorAll(
        ".mto-swatches-wrapper .swatch-box"
      );

      if ($inputs.length === 0) {
        // let isMto = await this.checkAndBuildMTo();

        // No MTO? Exit now.
        // if(!isMto) return;

        $inputs = document.querySelectorAll('input[name="product-type"]');
        allSwatches = document.querySelectorAll(
          ".mto-swatches-wrapper .swatch-box"
        );
      }

      function changeHandler(event) {
        const $input = event.target;
        const handle = $input.getAttribute("data-handle");
        const product = self.products[handle];
        const $selectorWrappers = document.querySelectorAll(
          ".productForm-block .selector-wrapper"
        );
        const $productSelector = document.getElementById("product-select");
        const $description = document.getElementById("description-container");
        const $productJson = document.getElementById("product-json");
        const $mtoDisclaimer = document.getElementById("mto-disclaimer");
        const isReadyToShip = /\((Ready To Ship|Ready-To-Ship)\)/gi.test(
          product.title
        );

        [...allSwatches].forEach(function ($swatch) {
          if ($swatch === $input.parentElement) {
            $swatch.classList.add("checked");
          } else {
            $swatch.classList.remove("checked");
          }
        });

        $productJson.innerHTML = JSON.stringify(product);

        self.state.main = product.handle;

        $selectorWrappers.forEach(function ($wrapper) {
          $wrapper.parentElement.removeChild($wrapper);
        });

        let newVariantIndex = self.state.variant
          ? [...product.variants].findIndex(function (variant) {
              return ["option1", "option2", "option3"].every((key) => {
                return self.state.variant[key]
                  ? variant[key] === self.state.variant[key] || !variant[key]
                  : true;
              });
            })
          : -1;

        newVariantIndex === -1 ? 0 : newVariantIndex;

        $productSelector.innerHTML = `
                  ${product.variants
                    .map(function (variant, index) {
                      return `
                      <option ${
                        index === newVariantIndex ? "selected" : ""
                      } value="${variant.id}" data-sku="${variant.sku}" data-qty="${variant.inventory_quantity}">
                            ${variant.title} - ${variant.price}
                      </option>
                      `;
                    })
                    .join("")}
                `;

        window.Product.variantsInit();

        document.querySelector(".main-product-row .product-title").textContent =
          product.title;
        // $mtoDisclaimer.style.display = (isReadyToShip) ? 'none' : 'block';
        $mtoDisclaimer.innerHTML = product.metafields.disclaimer;
        $description.innerHTML = product.description;

        self.ImageSwapHandler();
        self.destroyInfiniteOptions();
        self.loadInfiniteOptions();
      }

      $inputs.forEach(function ($input) {
        $input.addEventListener("change", changeHandler);
      });
    },
    ProductImages() {
      this.ImageZoom();
      this.ImageSliders();
    },
    products: {},
    productsJSON() {
      const $product = document.querySelector("script[data-product]");

      if (!$product) return;

      const $productMetas = document.querySelector(
        "script[data-product-metas]"
      );

      let product = JSON.parse($product.innerHTML);
      const metas = JSON.parse($productMetas.innerHTML);

      console.log("Product Metas", { metas });

      product.metafields = metas;

      this.products[product.handle] = product;
      this.state.main = product.handle;

      // const $companion = document.querySelector('script[data-companion-product]');

      // if($companion) {
      //     let companion = JSON.parse($companion.innerHTML);
      //     const $companionMetas = document.querySelector('script[data-companion-metas]');
      //     const companionMetas = JSON.parse($companionMetas.innerHTML);

      //     companion.metafields = companionMetas;

      //     companion = setupProductOptions(companion);

      //     this.products[companion.handle] = companion;
      //     this.state.companion = companion.handle;

      //     product.variants = product.variants.concat(companion.variants);
      //     this.products[product.handle] = product;
      // }
    },
    selectImageCallback(variant) {
      const product = this.products[this.state.main];
      const variantMetafieldImages = [
        ...product.metafields.variant_images,
      ].reduce((variant_images, { id, images }) => {
        if (variant.id !== id) return variant_images;

        return [...images];
      }, []);

      const currentMetafieldImages = [
        ...document.querySelectorAll(".metafield-slide"),
      ];

      [...currentMetafieldImages].forEach(($slide) => {
        const $slickSlide = $slide.parentElement;
        const index = $slickSlide.dataset.slickIndex;

        const $slick = $slickSlide.closest(".slick-slider");

        console.log("Remove slide:", { $slide, index, $slickSlide, $slick });

        $($slick).slick("slickRemove", index);
      });

      if (!variant || !variant.featured_image) return;

      const currentVariantImages = document.querySelectorAll(
        "[data-variant-image]"
      );

      const mainVariantSlide = `
                <div>
                    <div data-variant-image class="main-slide">
                        <figure class="zoom" style="background-image: url(${window.Shopify.Image.getSizedImageUrl(
                          variant.featured_image.src,
                          "2048x"
                        )})">
                            <img src="${window.Shopify.Image.getSizedImageUrl(
                              variant.featured_image.src,
                              "2048x"
                            )}" alt="${variant.featured_image.alt}" />
                        </figure>
                    </div>    
                </div>
            `;

      const thumbVariantSlide = `
            <div>
                <div class="thumb-slide"  data-variant-image>
                    <img src="${window.Shopify.Image.getSizedImageUrl(
                      variant.featured_image.src,
                      "244x"
                    )}" alt="${variant.featured_image.alt}" />
                </div>
            </div>
            `;

      let originalCount = $(".main-slider.slick-initialized").slick(
        "getSlick"
      ).slideCount;

      if (originalCount < 2) {
        setTimeout(function () {
          if (currentVariantImages.length) {
            [...currentVariantImages].forEach(($div) => {
              let $slide = $div.closest(".slick-slide");

              if (!$slide) return;

              if ($slide.classList.contains("slick-cloned")) return;

              let $slider = $div.classList.contains("thumb-slide")
                ? document.querySelector(".thumb-slider")
                : document.querySelector(".main-slider");

              if (!$slide || !$slider) return;

              const index = $slide.dataset.slickIndex;

              $($slider).slick("slickRemove", index);
            });
          }
        }, 150);

        let mainCount = $(".main-slider.slick-initialized").slick(
          "getSlick"
        ).slideCount;
        let thumbCount = $(".thumb-slider.slick-initialized").slick(
          "getSlick"
        ).slideCount;

        $(".main-slider.slick-initialized").slick(
          "slickAdd",
          mainVariantSlide,
          0,
          mainCount > -1
        );
        $(".thumb-slider.slick-initialized").slick(
          "slickAdd",
          thumbVariantSlide,
          0,
          thumbCount > -1
        );
      } else {
        if (currentVariantImages.length) {
          [...currentVariantImages].forEach(($div) => {
            let $slide = $div.closest(".slick-slide");

            if (!$slide) return;

            if ($slide.classList.contains("slick-cloned")) return;

            let $slider = $div.classList.contains("thumb-slide")
              ? document.querySelector(".thumb-slider")
              : document.querySelector(".main-slider");

            if (!$slide || !$slider) return;

            const index = $slide.dataset.slickIndex;

            $($slider).slick("slickRemove", index);
          });
        }

        let mainCount = $(".main-slider.slick-initialized").slick(
          "getSlick"
        ).slideCount;
        let thumbCount = $(".thumb-slider.slick-initialized").slick(
          "getSlick"
        ).slideCount;

        $(".main-slider.slick-initialized").slick(
          "slickAdd",
          mainVariantSlide,
          0,
          mainCount > 0
        );
        $(".thumb-slider.slick-initialized").slick(
          "slickAdd",
          thumbVariantSlide,
          0,
          thumbCount > 0
        );
      }

      [...variantMetafieldImages].forEach((image) => {
        let mainCount = $(".main-slider.slick-initialized").slick(
          "getSlick"
        ).slideCount;
        let thumbCount = $(".thumb-slider.slick-initialized").slick(
          "getSlick"
        ).slideCount;

        const html = `
                <div>
                    <div data-variant-image class="main-slide metafield-slide">
                        <figure class="zoom" style="background-image: url(${window.Shopify.Image.getSizedImageUrl(
                          image,
                          "2048x"
                        )})">
                            <img src="${window.Shopify.Image.getSizedImageUrl(
                              image,
                              "2048x"
                            )}" alt="" />
                        </figure>
                    </div>    
                </div>                
                `;

        const thumbVariantSlide = `
                <div>
                    <div class="thumb-slide metafield-slide"  data-variant-image>
                        <img src="${window.Shopify.Image.getSizedImageUrl(
                          image,
                          "244x"
                        )}" alt="" />
                    </div>
                </div>
                `;

        $(".main-slider.slick-initialized").slick(
          "slickAdd",
          html,
          0,
          mainCount > -1
        );
        $(".thumb-slider.slick-initialized").slick(
          "slickAdd",
          thumbVariantSlide,
          0,
          thumbCount > 0
        );
      });

      setTimeout(function () {
        $(".thumb-slider.slick-initialized").slick("setPosition");
        $("main-slider.slick-initialized").slick("setPosition");
      }, 500);
    },
    _getCurrentOptions() {
      const $singleOptionSelectors = document.querySelectorAll(
        ".variant-options-table .single-option-selector"
      );

      // get select variant options for the any selector w/ a value.
      return [...$singleOptionSelectors]
        .filter(($select) => $select.value.length)
        .map(($select) => ({
          value: $select.value,
          name: $select.dataset.option,
          index: Number($select.dataset.option.replace("option", "")),
        }));
    },
    closestMatchVariant(lastSelectedOption) {
      const currentlySelectedOptions = this._getCurrentOptions();
      const product = this.products[this.state.main];
      const variants = product.variants;

      const potentialAvailableMatches = [...variants].filter((variant) => {
        return [...currentlySelectedOptions].every((option) => {
          return variant[option.name] === option.value;
        });
      });

      return potentialAvailableMatches.length
        ? potentialAvailableMatches[0]
        : null;
    },
    selectCallback(variant, selector) {
      const $self = this;
      const $notifyContent = document.querySelector(
        ".product-info #contact_form"
      );
      const product = selector.product;
      const optionsSelectedFiltered = [...selector.selectors]
        .map((item) => item.element.value)
        .filter((value) => value.length);
      // console.log('PDP Select Callback', variant, selector, {product, selectorValues: [...selector.selectors].map((item) => item.element.value) });

      const optionsSelected = [...selector.selectors]
        .map((item) => item.element.value)
        .filter((value) => value.length);
      const $customSelects = document.querySelectorAll(
        '.selectCustom:not([data-option="0"])'
      );

      console.log("Select Callback!", {
        variant,
        selector,
        product: this.products[this.state.main],
      });

      // Is Size Actually MTO?
      if (optionsSelected.length === product.options.length && !variant) {
        let selectionsWithoutSize = [...optionsSelected].filter(
          (option, index) => product.options[index].toLowerCase() !== "size"
        );
        let sizeIndex = [...product.options].findIndex(
          (opt) => opt.toLowerCase() === "size"
        );

        optionsSelected[sizeIndex] = "Made To Order";

        let replacementVariant = [...product.variants].find((variant) => {
          return optionsSelected.every((selection, index) => {
            return (
              variant[`option${index + 1}`].toLowerCase() ===
              selection.toLowerCase()
            );
          });
        });

        let mtoValue = replacementVariant
          ? replacementVariant[`option${sizeIndex + 1}`]
          : null;
        let $selector = document.querySelector(
          `#product-select-option-${sizeIndex}`
        );

        if (mtoValue) {
          $selector.value = mtoValue;
          $selector.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }

      // Update Custom Selects if at least 1 selection is made.
      if (optionsSelectedFiltered.length) {
        [...$customSelects].forEach(($custom) => {
          let optionIndex = $custom.dataset.option;

          let previousSelections = [...optionsSelected].filter(
            (item, i) => i < Number(optionIndex)
          );
          let applicableVariants = [...product.variants].filter((v) => {
            return [...previousSelections].every(
              (o, index) => v[`option${index + 1}`] === o
            );
          });

          const dropdownOptions = $custom.querySelectorAll(".dropdown-option");

          [...dropdownOptions].forEach(($option) => {
            const value = $option.dataset.value;

            $option.setAttribute(
              "data-type",
              $self.optionCallback(
                {
                  value,
                  index: Number(optionIndex) + 1,
                },
                applicableVariants
              )
            );
          });
        });
      } else {
        [...$customSelects].forEach(($custom) => {
          let optionIndex = $custom.dataset.option;
          const dropdownOptions = $custom.querySelectorAll(".dropdown-option");

          [...dropdownOptions].forEach(($option) => {
            const value = $option.dataset.value;

            $option.setAttribute(
              "data-type",
              $self.optionCallback({
                value,
                index: Number(optionIndex) + 1,
              })
            );
          });
        });
      }

      // console.log('PDP Select Callback:', variant);
      this.updateMadeToOrderProperty(variant);

      this.state.variant = variant;

      this.updateBtn({
        variant,
        optionsSelected: optionsSelectedFiltered,
      });

      const imgVariant = variant || this.closestMatchVariant();

      if (variant) {
        document.getElementById("product-select").value = variant.id;
      }

      if (imgVariant) {
        this.selectImageCallback(imgVariant);
      }

      if ($notifyContent && variant.available) {
        $notifyContent.style.display = "none";
      }

      if ($notifyContent && !variant.available) {
        $notifyContent.style.display = "block";
      }

      if (variant) {
        let quantity = document.querySelector("#quantity").value || 1;
        let price = window.Shopify.formatMoney(
          variant.price * quantity,
          "${{amount_no_decimals}}"
        );

        let $price = document.querySelector(".product-normal-price");

        $price.textContent = price;
      }
    },
    state: {
      main: null,
      infiniteOptionsData: null,
      addons: null,
    },
    tabs() {
      const tabControls = document.querySelectorAll(".tab-control li");
      const allTabs = document.querySelectorAll(
        '.main-tab div[role="tabpanel"]'
      );

      function controlClickHandler(event) {
        const target = event.currentTarget;
        const controls = target.getAttribute("aria-controls");
        const $controls = document.getElementById(controls);

        tabControls.forEach(function ($li) {
          const expanded = $li === target ? "true" : "false";
          $li.setAttribute("aria-selected", expanded);
        });

        allTabs.forEach(function ($tab) {
          const expanded = $tab === $controls ? "true" : "false";

          $tab.setAttribute("aria-expanded", expanded);
        });
      }

      tabControls.forEach(function ($control) {
        $control.addEventListener("click", controlClickHandler);
      });
    },
    updateBtn({ variant = null, optionsSelected }) {
      const $btn = document.querySelector("button.productForm-submit");
      const productTypeSelection = document.querySelector(
        'input[name="product-type"]:checked'
      );
      const $mtoDisclaimer = document.getElementById("mto-disclaimer");

      if (productTypeSelection) {
        const productType = productTypeSelection.value;
        const currentBtnText = $btn.textContent;
        const nextBtnText = currentBtnText.replace(
          /(\|.*|$)/i,
          `&nbsp;&nbsp;|&nbsp;&nbsp;${productType}`
        );

        // console.log('Next Text?', nextBtnText);
        $btn.innerHTML = nextBtnText;
        $mtoDisclaimer.style.display = "block";
      } else {
      }
      // // console.log('Product Type Selection', productTypeSelection);
    },
  };

  window.PDP = PDP;
  PDP.init();
  window.PDP.checkCartState();
})(window.$ || window.jQuery);
